// @ts-nocheck

function rpOnReady(fn) {
    if (typeof fn !== 'function') return;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
}

export function initRpGlobe() {

/**
 * rp-globe.js — Hero do radios.pro com globo 3D estilo radio.garden.
 *
 * Fluxo:
 *  1. Carrega globe.gl via CDN após load + idle (não compete com rádios/PROton).
 *     Textura leve no primeiro paint; upgrade progressivo até 8K conforme zoom.
 *  2. Fetch /ajax/ajax-radios-globe.php?zoom=3 → clusters + coord do utilizador.
 *  3. Renderiza clusters como pontos achatados (gradiente azul→ciano).
 *  4. Centra a câmara na coord do utilizador (geo-IP server-side) + ring "you are here".
 *  5. Click num cluster → abre um modal 2D com mapa Leaflet da região, marcadores
 *     são as estações reais buscadas via /ajax/ajax-cluster-stations.php.
 *  6. Click num marcador no mapa 2D → window.radioManager.playRadio(...).
 *
 * Fallback: respeita prefers-reduced-motion. Se globe.gl ou Leaflet falharem
 * a carregar, o hero mantém os orbs decorativos originais.
 */
(function () {
    'use strict';

    var ENDPOINT_GLOBE = '/ajax/ajax-radios-globe.php';
    var ENDPOINT_CLUSTER = '/ajax/ajax-cluster-stations.php';

    var GLOBE_GL_URL = 'https://cdn.jsdelivr.net/npm/globe.gl@2.34.4/dist/globe.gl.min.js';
    // Texturas hospedadas localmente — evita hotlink protection + CORS issues.
    // earth-night-2k.jpg no servidor é ~1600×800 (fallback leve); hi-res nativo 8192×4096.
    var GLOBE_IMAGE_URL_LOW = '/assets/img/textures/earth-night-2k.dat';
    var GLOBE_IMAGE_URL_LOW_FALLBACK = '/assets/img/textures/earth-night-2k.jpg';
    var GLOBE_IMAGE_URL_HIGH = '/assets/img/textures/earth-night-8k.dat';
    var GLOBE_BUMP_URL = 'https://unpkg.com/three-globe@2.31.1/example/img/earth-topology.png';
    var GLOBE_HI_RES_MAX_PX = 4096;       // cap tier medium
    var GLOBE_HI_RES_MAX_PX_HIGH = 8192;  // fonte nativa 8192×4096 no tier high
    var GLOBE_HI_RES_INTERACTION_MS = 12000;
    var GLOBE_POINT_ALTITUDE = 0.001;
    var POINT_BASE_SIZE = 4.5;          // px de tela do sprite em altitude padrão

    var LEAFLET_CSS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    var LEAFLET_JS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    // Plugin de clustering — agrupa marcadores empilhados (TopContents geocoda
    // pela cidade, então muitas rádios da mesma cidade têm coord idêntica).
    var LEAFLET_CLUSTER_CSS_URL = 'https://unpkg.com/leaflet.markercluster@1.5.3/dist/MarkerCluster.css';
    var LEAFLET_CLUSTER_DEFAULT_CSS_URL = 'https://unpkg.com/leaflet.markercluster@1.5.3/dist/MarkerCluster.Default.css';
    var LEAFLET_CLUSTER_JS_URL = 'https://unpkg.com/leaflet.markercluster@1.5.3/dist/leaflet.markercluster.js';
    // Tiles raster do OSM — ruas, bairros, cidades com detalhe completo.
    // openstreetmap.org permite uso sem chave para tráfego baixo/moderado
    // (https://operations.osmfoundation.org/policies/tiles/). Sem CARTO, sem API key.
    var REGION_TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
    var REGION_TILE_ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';
    var REGION_MAP_BACKGROUND = '#081321';
    // GeoJSON vetorial local: países + estados usados no zoom distante; no zoom
    // próximo os tiles OSM assumem o detalhe (ruas/bairros) e o vetorial some.
    var REGION_GEOGRAPHY_URL = '/assets/data/world-countries.geojson';
    var REGION_ADMIN1_URL = '/assets/data/world-admin1.geojson';
    var regionGeographyPromise = null;
    var regionAdmin1Promise = null;

    var REGION_RADIUS_KM = 200;   // raio buscado em volta do cluster clicado
    var REGION_STATION_LIMIT = 200;

    var canvas = document.getElementById('rp-globe-canvas');
    if (!canvas) return;

    var hero = canvas.closest('.rp-hero');
    var userInfoEl = document.getElementById('rp-globe-user-info');
    var globeLoadingEl = document.getElementById('rp-globe-loading');
    var discoverBtn = document.getElementById('rp-globe-discover');
    var globeInitStarted = false;
    var discoveryMode = false;

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobileGlobe = window.matchMedia && window.matchMedia('(max-width: 720px)').matches;

    /** low = 2K fixo | medium = 2K + 4K após interação | high = idem + bump + crossfade */
    function detectGlobePerfTier() {
        if (isMobileGlobe) return 'low';
        try {
            var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
            if (conn && (conn.saveData || /(^|-)2g/.test(conn.effectiveType || ''))) return 'low';
        } catch (e) { /* noop */ }
        if (navigator.deviceMemory && navigator.deviceMemory <= 4) return 'low';
        if (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) return 'medium';
        if (navigator.deviceMemory && navigator.deviceMemory >= 8
            && navigator.hardwareConcurrency && navigator.hardwareConcurrency >= 8) {
            return 'high';
        }
        return 'medium';
    }

    var globePerfTier = detectGlobePerfTier();
    var globeRenderPaused = false;
    var hiResInteractionBound = false;
    if (prefersReduced) {
        if (globeLoadingEl) globeLoadingEl.classList.add('is-hidden');
        return;
    }

    var globe = null;
    var userCoord = null;
    var autoRotateResumeTimer = null;
    var textureUpgraded = false;       // true quando a textura hi-res está ativa
    var textureAppliedMaxPx = 0;       // largura em px da textura já aplicada na GPU
    var hiResSourceBlob = null;        // blob 8K em cache (evita re-download ao subir LOD)
    var hiResFetchPromise = null;
    var lowResBlobUrl = null;
    var textureZoomSyncTimer = null;
    var textureSharpenTimer = null;    // adia anisotropia/mipmaps após troca de textura
    var textureCrossfadeRaf = null;    // animação 2K → 8K no shader
    var GLOBE_TEXTURE_CROSSFADE_MS = 520;

    var globeMode = '3d';               // '3d' | 'flat'
    var flatFeedLoaded = false;         // zoom=5 já buscado?
    var flatFeedLoading = false;

    var regionOverlay = null;
    var regionMap = null;
    var regionMarkers = [];
    var regionMarkersById = {};        // id → marker (para diff em vez de clearLayers)
    var regionClusterGroup = null;
    var leafletLoading = null;
    // Estado do refetch dinâmico ao panar/zoom no mapa 2D
    var regionMoveAttached = false;
    var regionMoveDebounce = null;
    var regionSkipNextMoveEnd = false;  // ignora o moveend que dispara após fitBounds programático
    var regionLastFetchCenter = null;   // L.LatLng do último centro fetched
    var regionLastFetchRadius = 0;      // km
    var regionOpenToken = 0;            // invalida fetches/renders de aberturas anteriores
    var regionDataMode = 'stations';    // stations locais ou clusters globais do globo
    var regionWorldZoom = null;
    var regionWorldPendingZoom = null;
    var regionFetchToken = 0;
    var regionResizeTimers = [];

    // LOD: zoom level dos clusters muda conforme a altitude da câmara.
    // Cap em 4 (810 clusters) — zoom=5 (1915) é pesado e excede o ganho
    // visual; região fina o utilizador resolve abrindo o modal 2D.
    var currentZoomLevel = FLAT_FEED_ZOOM; // feed completo (todos os pontos) desde o início
    var clustersCache = {};         // por zoom level (in-memory)
    var zoomFetchDebounce = null;

    // Hover nos clusters do globo 3D
    var globePoints = [];
    var hoveredGlobePoint = null;

    // -- Histerese e transições suaves de LOD --------------------------------
    var ZOOM_HYSTERESIS_ZOOM_IN = { 1: 2.4, 2: 1.6, 3: 0.8, 4: 0.3 };
    var ZOOM_HYSTERESIS_ZOOM_OUT = { 2: 3.0, 3: 2.2, 4: 1.2, 5: 0.5 };
    var CLUSTER_TRANSITION_MS = 1600; // (legado: era tween de pontos; hoje só doc)
    var CLUSTER_DEBOUNCE_MS = 800;
    // visualUpdateTimer removido — não há mais throttle contínuo de tamanho

    function getDiscoverLabels() {
        if (!discoverBtn) {
            return { enter: 'Explorar no mapa', exit: 'Voltar à busca' };
        }
        return {
            enter: discoverBtn.getAttribute('data-label-enter') || 'Explorar no mapa',
            exit: discoverBtn.getAttribute('data-label-exit') || 'Voltar à busca',
        };
    }

    function updateDiscoveryGlobeInset() {
        if (!hero) return;
        if (!discoveryMode) {
            hero.style.removeProperty('--rp-hero-discovery-top');
            return;
        }

        var h = measureDiscoveryContentHeight();
        if (h == null) {
            var content = hero.querySelector('.rp-hero-content');
            if (!content) return;
            h = content.getBoundingClientRect().height;
            // Fallback: controles de busca colapsam (max-height → 0) no modo descoberta.
            var ctrls = hero.querySelector('.rp-hero-search .figma-search-controls');
            if (ctrls) h -= ctrls.getBoundingClientRect().height;
        }
        if (h < 0) h = 0;
        hero.style.setProperty('--rp-hero-discovery-top', (Math.ceil(h) + 32) + 'px');
    }

    function measureDiscoveryContentHeight() {
        if (!hero) return null;
        var content = hero.querySelector('.rp-hero-content');
        if (!content) return null;

        var shell = document.createElement('div');
        shell.className = hero.className || 'rp-hero';
        shell.classList.add('is-discovery-mode');
        shell.classList.remove('is-globe-transitioning', 'has-globe', 'is-interacted');
        shell.setAttribute('aria-hidden', 'true');
        shell.style.cssText = [
            'position:absolute',
            'left:-10000px',
            'top:0',
            'visibility:hidden',
            'pointer-events:none',
            'width:' + Math.ceil(hero.getBoundingClientRect().width || window.innerWidth) + 'px',
            'height:auto',
            'min-height:0',
            'overflow:visible',
            'contain:layout style paint'
        ].join(';');

        var clone = content.cloneNode(true);
        clone.querySelectorAll('[id]').forEach(function (el) {
            el.removeAttribute('id');
        });
        shell.appendChild(clone);
        document.body.appendChild(shell);

        var h = clone.getBoundingClientRect().height;
        document.body.removeChild(shell);
        return h;
    }

    /** Altura-alvo do hero no modo descoberta (espelha o CSS min(580px, 68vh)). */
    function discoveryTargetHeight() {
        return Math.min(580, Math.ceil(window.innerHeight * 0.68));
    }

    var HERO_GLOBE_TRANSITION_MS = 660;
    var HERO_TEXTURE_UPGRADE_DELAY_MS = 1100;
    var HERO_GLOBE_SETTLE_RESIZE_MS = 220;
    var _heroNaturalHeight = null;  // altura natural (fora do discovery mode)
    var _heroTransitionEndTimer = null;
    var _heroTransitionResizeRaf = null;
    var _heroSettleResizeTimer = null;
    var _heroTextureTimer = null;   // adia upgrade de textura até a animação terminar
    var _heroTransitionToken = 0;

    /** Anima a altura do hero de forma suave via CSS transition.
     *
     *  CSS não consegue interpolar min-height (auto → valor numérico), então
     *  usamos height explícito em px. Durante a transição, o renderer acompanha
     *  cada frame sem CSS esticar o canvas; o ajuste fino fica para depois.
     *
     *  IMPORTANTE: o caller (setDiscoveryMode) já mediu `startH` ANTES de trocar
     *  a classe e já travou inline height/min-height para a classe não dar snap.
     *  Aqui só registramos a transição e animamos até o alvo correto. */
    function animateHeroAndResizeGlobe(startH) {
        if (!hero) return;
        var transitionToken = ++_heroTransitionToken;
        if (_heroTransitionEndTimer) {
            clearTimeout(_heroTransitionEndTimer);
            _heroTransitionEndTimer = null;
        }
        if (_heroTransitionResizeRaf) {
            cancelAnimationFrame(_heroTransitionResizeRaf);
            _heroTransitionResizeRaf = null;
        }
        if (_heroSettleResizeTimer) {
            clearTimeout(_heroSettleResizeTimer);
            _heroSettleResizeTimer = null;
        }

        hero.classList.add('is-globe-transitioning');
        resize({ skipSharpen: true });

        hero.style.height = startH + 'px';
        hero.style.minHeight = '0';
        hero.offsetHeight; // reflow para fixar startH antes da transição
        hero.style.transition = 'height ' + HERO_GLOBE_TRANSITION_MS + 'ms cubic-bezier(0.22, 1, 0.36, 1)';

        requestAnimationFrame(function () {
            if (!hero) return;
            var targetH = discoveryMode
                ? discoveryTargetHeight()
                : (_heroNaturalHeight || startH);
            hero.style.height = targetH + 'px';

            function resizeTick() {
                if (!hero || transitionToken !== _heroTransitionToken) return;
                resize({ skipSharpen: true });
                _heroTransitionResizeRaf = requestAnimationFrame(resizeTick);
            }

            _heroTransitionResizeRaf = requestAnimationFrame(resizeTick);
            _heroTransitionEndTimer = setTimeout(function () {
                finishHeroTransition(transitionToken);
            }, HERO_GLOBE_TRANSITION_MS + 90);
        });
    }

    function finishHeroTransition(transitionToken) {
        if (!hero || transitionToken !== _heroTransitionToken) return;
        if (_heroTransitionEndTimer) {
            clearTimeout(_heroTransitionEndTimer);
            _heroTransitionEndTimer = null;
        }
        if (_heroTransitionResizeRaf) {
            cancelAnimationFrame(_heroTransitionResizeRaf);
            _heroTransitionResizeRaf = null;
        }

        hero.classList.remove('is-globe-transitioning');
        hero.style.height = '';
        hero.style.minHeight = '';
        hero.style.transition = '';
        updateDiscoveryGlobeInset();

        _heroSettleResizeTimer = setTimeout(function () {
            if (!hero || transitionToken !== _heroTransitionToken) return;
            _heroSettleResizeTimer = null;
            resizeIfNeeded({ skipSharpen: true, threshold: 3 });
            if (!discoveryMode) _heroNaturalHeight = null;
        }, HERO_GLOBE_SETTLE_RESIZE_MS);
    }

    function setDiscoveryMode(on, options) {
        options = options || {};

        // 1. Mede a altura ATUAL antes de qualquer troca de classe.
        var startH = hero ? Math.ceil(hero.getBoundingClientRect().height) : 0;
        discoveryMode = !!on;

        if (hero) {
            // 2. Trava a altura/min-height inline ANTES de trocar a classe, para
            //    que a mudança de min-height (CSS discovery) não dê snap brusco.
            hero.style.height = startH + 'px';
            hero.style.minHeight = '0';
            hero.offsetHeight; // reflow
            hero.classList.toggle('is-discovery-mode', discoveryMode);
            hero.classList.remove('is-interacted');
        }

        // 3. Guarda a altura natural só ao ENTRAR (startH aqui é a pré-discovery).
        if (discoveryMode) _heroNaturalHeight = startH;

        var labels = getDiscoverLabels();
        if (discoverBtn) {
            discoverBtn.setAttribute('aria-pressed', discoveryMode ? 'true' : 'false');
            discoverBtn.textContent = discoveryMode ? labels.exit : labels.enter;
        }
        if (!discoveryMode && globe) {
            try {
                var c = globe.controls();
                if (c) {
                    c.autoRotate = true;
                    updateRotateButtonState();
                }
            } catch (e) { /* noop */ }
        }
        if (options.focusSearch && !discoveryMode) {
            var searchInput = document.getElementById('rp-search-input');
            if (searchInput) searchInput.focus({ preventScroll: true });
        }

        // 4. Posiciona o alvo do globo já no valor final → desliza uma única vez.
        if (discoveryMode) updateDiscoveryGlobeInset();
        else if (hero) hero.style.removeProperty('--rp-hero-discovery-top');

        // 5. Anima a altura do hero e redimensiona o globo em passos leves.
        animateHeroAndResizeGlobe(startH);

        // 6. Upgrade pesado de textura só DEPOIS da transição (evita travar a
        //    animação por congelar a thread principal ao decodificar o 8K).
        if (_heroTextureTimer) {
            clearTimeout(_heroTextureTimer);
            _heroTextureTimer = null;
        }
        if (globe && discoveryMode) {
            _heroTextureTimer = setTimeout(function () {
                _heroTextureTimer = null;
                if (!globe || !discoveryMode) return;
                applyTextureSharpening();
                requestTextureUpgradeNow();
            }, HERO_TEXTURE_UPGRADE_DELAY_MS);
        }
    }

    function enterDiscoveryMode() {
        if (discoveryMode) return;
        setDiscoveryMode(true);
        if (hero && typeof hero.scrollIntoView === 'function') {
            hero.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    }

    function exitDiscoveryMode(options) {
        if (!discoveryMode) return;
        setDiscoveryMode(false, options || {});
    }

    function toggleDiscoveryMode() {
        if (discoveryMode) {
            exitDiscoveryMode({ focusSearch: true });
        } else {
            enterDiscoveryMode();
        }
    }

    // -- Utils ----------------------------------------------------------------

    function escapeHtml(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function loadScript(src) {
        return new Promise(function (resolve, reject) {
            if (document.querySelector('script[data-rp-src="' + src + '"]')) return resolve();
            var s = document.createElement('script');
            s.src = src;
            s.async = true;
            s.dataset.rpSrc = src;
            s.onload = resolve;
            s.onerror = function () { reject(new Error('Failed to load: ' + src)); };
            document.head.appendChild(s);
        });
    }

    function loadCss(href) {
        return new Promise(function (resolve, reject) {
            if (document.querySelector('link[href="' + href + '"]')) return resolve();
            var l = document.createElement('link');
            l.rel = 'stylesheet';
            l.href = href;
            l.onload = resolve;
            l.onerror = function () { reject(new Error('Failed to load: ' + href)); };
            document.head.appendChild(l);
        });
    }

    function fetchJson(url) {
        return fetch(url, { credentials: 'same-origin' }).then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
        });
    }

    function debounce(fn, ms) {
        var t = null;
        return function () {
            var args = arguments, ctx = this;
            if (t) clearTimeout(t);
            t = setTimeout(function () { fn.apply(ctx, args); }, ms);
        };
    }

    function toRad(deg) { return deg * Math.PI / 180; }
    function toDeg(rad) { return rad * 180 / Math.PI; }

    function haversineKm(lat1, lng1, lat2, lng2) {
        var r = 6371;
        var dLat = toRad(lat2 - lat1);
        var dLng = toRad(lng2 - lng1);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
            + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
        return r * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function bearingDeg(lat1, lng1, lat2, lng2) {
        var phi1 = toRad(lat1);
        var phi2 = toRad(lat2);
        var dLng = toRad(lng2 - lng1);
        var y = Math.sin(dLng) * Math.cos(phi2);
        var x = Math.cos(phi1) * Math.sin(phi2) - Math.sin(phi1) * Math.cos(phi2) * Math.cos(dLng);
        return (toDeg(Math.atan2(y, x)) + 360) % 360;
    }

    function destinationLatLng(lat, lng, bearing, distanceKm) {
        var r = 6371;
        var delta = distanceKm / r;
        var theta = toRad(bearing);
        var phi1 = toRad(lat);
        var lambda1 = toRad(lng);
        var phi2 = Math.asin(
            Math.sin(phi1) * Math.cos(delta)
            + Math.cos(phi1) * Math.sin(delta) * Math.cos(theta)
        );
        var lambda2 = lambda1 + Math.atan2(
            Math.sin(theta) * Math.sin(delta) * Math.cos(phi1),
            Math.cos(delta) - Math.sin(phi1) * Math.sin(phi2)
        );
        return {
            lat: toDeg(phi2),
            lng: ((toDeg(lambda2) + 540) % 360) - 180
        };
    }

    function hoverPushZoneKm(zoom) {
        return ({ 1: 1100, 2: 680, 3: 360, 4: 170, 5: 85 })[zoom] || 360;
    }

    function hoverPushStrengthKm(zoom) {
        return ({ 1: 42, 2: 26, 3: 15, 4: 8.5, 5: 4.5 })[zoom] || 15;
    }

    // -- Clusters como sprites 2D (estilo radio.garden) ------------------------
    // Um único THREE.Points (1 draw call). O vertex shader fixa o tamanho em
    // pixels de tela (constante em qualquer altitude) e o fragment shader recorta
    // o quadrado em círculo. Nada de cilindros 3D de milhares de vértices.
    var spriteLayerGroup = null;
    var spriteLayerBuilt = false;
    var spriteUniforms = null;
    var spriteRaycaster = null;
    var spriteMouseNdc = null;

    function latLngToSceneVec3(lat, lng, radius) {
        // Convenção idêntica ao three-globe (polar2Cartesian) — obrigatória para
        // os sprites caírem sobre o mesmo ponto da textura que os clusters antigos.
        var phi = (90 - lat) * Math.PI / 180;
        var theta = (90 - lng) * Math.PI / 180;
        var r = radius;
        return {
            x: r * Math.sin(phi) * Math.cos(theta),
            y: r * Math.cos(phi),
            z: r * Math.sin(phi) * Math.sin(theta)
        };
    }

    function buildSpriteLayer() {
        var THREE = getTHREE();
        if (!THREE) {
            // THREE ainda carregando (ESM do CDN). Tenta de novo quando chegar.
            window.addEventListener('rp-three-ready', function () { buildSpriteLayer(); });
            return;
        }
        if (spriteLayerBuilt || !globe) return;
        var scene = (typeof globe.scene === 'function') ? globe.scene() : null;
        if (!scene) return;

        spriteUniforms = {
            uScale: { value: (window.innerHeight || 900) * 0.5 },
            uPixelRatio: { value: (typeof getGlobeMaxDpr === 'function' ? getGlobeMaxDpr() : (window.devicePixelRatio || 1)) }
        };

        var positions = new Float32Array(globePoints.length * 3);
        var colors = new Float32Array(globePoints.length * 3);
        var sizes = new Float32Array(globePoints.length);
        var R = 100.9; // fora da superfície: evita afundar no horizonte; com depthTest on, o lado oposto é ocultado pelo planeta
        for (var i = 0; i < globePoints.length; i++) {
            var p = globePoints[i];
            var v = latLngToSceneVec3(p.lat, p.lng, R);
            positions[i * 3] = v.x; positions[i * 3 + 1] = v.y; positions[i * 3 + 2] = v.z;
            var c = new THREE.Color(p.color);
            colors[i * 3] = c.r; colors[i * 3 + 1] = c.g; colors[i * 3 + 2] = c.b;
            sizes[i] = POINT_BASE_SIZE * (0.65 + 0.7 * Math.min(1, (p.count || 1) / 500)); // tamanho por densidade
        }

        var geometry = new THREE.BufferGeometry();
        geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
        geometry.setAttribute('aColor', new THREE.BufferAttribute(colors, 3));
        geometry.setAttribute('aSize', new THREE.BufferAttribute(sizes, 1));

        var material = new THREE.ShaderMaterial({
            uniforms: spriteUniforms,
            transparent: true,
            depthWrite: false,
            depthTest: true,
            vertexShader: [
                'attribute vec3 aColor;',
                'attribute float aSize;',
                'uniform float uScale;',
                'uniform float uPixelRatio;',
                'varying vec3 vColor;',
                'void main() {',
                '    vColor = aColor;',
                '    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);',
                '    gl_Position = projectionMatrix * mvPosition;',
                '    float ps = aSize * uPixelRatio * (uScale / -mvPosition.z);',
                '    gl_PointSize = clamp(ps, 2.5, 11.0);',
                '}'
            ].join('\n'),
            fragmentShader: [
                'varying vec3 vColor;',
                'void main() {',
                '    vec2 uv = gl_PointCoord - vec2(0.5);',
                '    float d = length(uv);',
                '    if (d > 0.5) discard;',
                '    float edge = smoothstep(0.5, 0.42, d);',
                '    gl_FragColor = vec4(vColor, edge * 0.95);',
                '}'
            ].join('\n')
        });

        spriteLayerGroup = new THREE.Points(geometry, material);
        scene.add(spriteLayerGroup);
        spriteLayerBuilt = true;

        spriteRaycaster = new THREE.Raycaster();
        spriteRaycaster.params = spriteRaycaster.params || {};
        spriteRaycaster.params.Points = { threshold: 0.9 };
        spriteMouseNdc = new THREE.Vector2();

        // Raycast para hover/click nos sprites.
        canvas.addEventListener('pointermove', onSpritePointerMove, { passive: true });
        canvas.addEventListener('pointerup', onSpritePointerUp, { passive: true });
    }

    var threeLoadingStarted = false;
    function getTHREE() {
        // globe.gl moderno não expõe THREE global; carregamos o build ESM do three
        // uma única vez e capturamos o namespace no window quando pronto.
        if (window.__rpTHREE) return window.__rpTHREE;
        if (!threeLoadingStarted) {
            threeLoadingStarted = true;
            var s = document.createElement('script');
            s.type = 'module';
            s.textContent = [
                "import * as T from 'https://cdn.jsdelivr.net/npm/three@0.171.0/build/three.module.min.js';",
                'window.__rpTHREE = T;',
                "window.dispatchEvent(new Event('rp-three-ready'));"
            ].join('\n');
            document.head.appendChild(s);
        }
        return null;
    }

    function spriteNdcFromEvent(ev) {
        var rect = canvas.getBoundingClientRect();
        spriteMouseNdc.x = ((ev.clientX - rect.left) / rect.width) * 2 - 1;
        spriteMouseNdc.y = -((ev.clientY - rect.top) / rect.height) * 2 + 1;
    }

    function spriteIntersect(ev) {
        if (!spriteLayerGroup || !spriteRaycaster) return null;
        var cam = globe.camera();
        if (!cam) return null;
        spriteNdcFromEvent(ev);
        spriteRaycaster.setFromCamera(spriteMouseNdc, cam);
        var hits = spriteRaycaster.intersectObject(spriteLayerGroup, false);
        if (!hits || !hits.length) return null;
        return globePoints[hits[0].index] || null;
    }

    function onSpritePointerMove(ev) {
        var p = spriteIntersect(ev);
        onGlobePointHover(p);
    }

    function onSpritePointerUp(ev) {
        var p = spriteIntersect(ev);
        if (p) onClusterClick(p);
    }

    function resetGlobePointLayout() {
        var sizeMul = continuousSizeMultiplier(getCameraAltitude());
        globePoints.forEach(function (p) {
            p.lat = p.baseLat;
            p.lng = p.baseLng;
            p.radius = p.baseRadius * sizeMul;
            p.altitude = p.baseAltitude;
        });
    }

    /** Expande o ponto hovered e empurra levemente os vizinhos na superfície.
     *  Aplica também o multiplicador contínuo de tamanho (por altitude) para
     *  que o hover mantenha consistência com o zoom atual. */
    function applyGlobeHoverLayout() {
        resetGlobePointLayout();
        if (!hoveredGlobePoint) return;

        var h = hoveredGlobePoint;
        var currentSizeMul = continuousSizeMultiplier(getCameraAltitude());

        // Só o ponto sob o cursor destaca; o "empurrão" dos vizinhos (que dava
        // impressão de pop-up espalhado) ficou restrito a zooms fechados.
        h.radius = h.baseRadius * 1.35 * currentSizeMul;
        h.altitude = h.baseAltitude * 1.15;

        if (currentZoomLevel < 4) return;
        var zoneKm = hoverPushZoneKm(currentZoomLevel);
        var maxPushKm = hoverPushStrengthKm(currentZoomLevel);

        globePoints.forEach(function (p) {
            if (p === h) return;
            var dist = haversineKm(h.baseLat, h.baseLng, p.baseLat, p.baseLng);
            if (dist <= 0.001 || dist > zoneKm) return;

            var influence = Math.pow(1 - dist / zoneKm, 1.55);
            var pushKm = maxPushKm * influence;
            var brng = bearingDeg(h.baseLat, h.baseLng, p.baseLat, p.baseLng);
            var dest = destinationLatLng(p.baseLat, p.baseLng, brng, pushKm);
            p.lat = dest.lat;
            p.lng = dest.lng;
            p.radius = p.baseRadius * (1 - 0.08 * influence) * currentSizeMul;
        });
    }

    function refreshGlobePoints(transitionMs) {
        if (!globe || !globePoints.length) return;
        applyGlobeHoverLayout();
        updateSpriteHoverState();
    }

    /** Reflete o hover no atributo de tamanho do sprite destacado. */
    function updateSpriteHoverState() {
        if (!spriteLayerGroup || !spriteLayerGroup.geometry) return;
        var attr = spriteLayerGroup.geometry.getAttribute('aSize');
        if (!attr) return;
        for (var i = 0; i < globePoints.length; i++) {
            var p = globePoints[i];
            var base = POINT_BASE_SIZE * (0.65 + 0.7 * Math.min(1, (p.count || 1) / 500));
            attr.setX(i, (hoveredGlobePoint === p) ? base * 1.45 : base);
        }
        attr.needsUpdate = true;
    }

    var hoverRefreshPending = false;
    function onGlobePointHover(point) {
        if (point === hoveredGlobePoint) return;
        hoveredGlobePoint = point || null;
        if (canvas) canvas.style.cursor = point ? 'pointer' : '';
        // pointsMerge: cada refresh reconstrói a geometria — faz throttled em vez de por-ponto.
        if (hoverRefreshPending) return;
        hoverRefreshPending = true;
        setTimeout(function () {
            hoverRefreshPending = false;
            refreshGlobePoints(0);
        }, 120);
    }

    /** Gradiente azul → violeta → ciano para densidade dos clusters. */
    function colorForCount(count, maxCount, zoomLevel) {
        var t = Math.min(1, Math.log10(count + 1) / Math.log10(maxCount + 1));
        var h, s, l;
        if (t < 0.5) {
            var k1 = t * 2;
            h = 220 + k1 * 50;
            s = 80 + k1 * 5;
            l = 55 + k1 * 5;
        } else {
            var k2 = (t - 0.5) * 2;
            h = 270 - k2 * 80;
            s = 85 + k2 * 5;
            l = 60 + k2 * 5;
        }
        var glow = pointGlowForZoom(zoomLevel);
        s = Math.max(62, Math.min(100, s * glow.saturation));
        l = Math.max(56, Math.min(94, l * glow.lightness + glow.lift));
        return 'hsl(' + h + ',' + s + '%,' + l + '%)';
    }

    function setUserInfoLoading(visible) {
        if (!userInfoEl) return;
        var loading = userInfoEl.querySelector('.rp-globe-user-info-loading');
        var textEl = userInfoEl.querySelector('.rp-globe-user-info-text');
        if (visible) {
            userInfoEl.hidden = false;
            userInfoEl.classList.add('is-loading');
            if (loading) loading.hidden = false;
            if (textEl) {
                textEl.hidden = true;
                textEl.textContent = '';
            }
            userInfoEl.setAttribute('aria-busy', 'true');
            return;
        }
        userInfoEl.classList.remove('is-loading');
        userInfoEl.removeAttribute('aria-busy');
        if (loading) loading.hidden = true;
    }

    function showUserInfo(user) {
        if (!userInfoEl) return;
        var textEl = userInfoEl.querySelector('.rp-globe-user-info-text');
        if (!user) {
            setUserInfoLoading(false);
            userInfoEl.hidden = true;
            if (textEl) textEl.textContent = '';
            return;
        }
        var bits = [];
        if (user.city) bits.push(user.city);
        if (user.region && user.region !== user.city) bits.push(user.region);
        if (user.country_code) bits.push(user.country_code);
        if (bits.length === 0) {
            setUserInfoLoading(false);
            userInfoEl.hidden = true;
            if (textEl) textEl.textContent = '';
            return;
        }
        setUserInfoLoading(false);
        if (textEl) {
            textEl.textContent = bits.join(', ');
            textEl.hidden = false;
        } else {
            userInfoEl.textContent = bits.join(', ');
        }
        userInfoEl.hidden = false;
    }

    // -- Globe ---------------------------------------------------------------

    function setGlobeLoading(visible) {
        if (!globeLoadingEl) return;
        globeLoadingEl.classList.toggle('is-hidden', !visible);
        globeLoadingEl.setAttribute('aria-busy', visible ? 'true' : 'false');
    }

    function hideGlobeLoading() {
        setGlobeLoading(false);
    }

    /** Espera o grid de rádios (prioridade no first paint) antes do WebGL pesado. */
    function waitForRadiosGridReady() {
        return new Promise(function (resolve) {
            if (window.__rpRadiosGridReady) {
                resolve();
                return;
            }
            var settled = false;
            function finish() {
                if (settled) return;
                settled = true;
                resolve();
            }
            document.addEventListener('rp-radios-grid-ready', finish, { once: true });
            setTimeout(finish, isMobileGlobe ? 9000 : 7000);
        });
    }

    /** Remove Three legado do Vanta (r134) antes do globe.gl (r171+). */
    function clearStaleThreeBeforeGlobe() {
        try {
            if (!window.__THREE__ || !window.THREE || window.THREE.REVISION == null) return;
            var rev = parseInt(window.THREE.REVISION, 10);
            if (!isNaN(rev) && rev < 154) {
                delete window.__THREE__;
                window.THREE = undefined;
            }
        } catch (e) { /* noop */ }
    }

    /** Adia o globo até a página crítica (rádios, PROton) estabilizar. */
    function scheduleGlobeInit() {
        setGlobeLoading(true);
        setUserInfoLoading(true);

        var start = function () {
            if (globeInitStarted) return;
            globeInitStarted = true;
            init();
        };

        var runDeferred = function () {
            waitForRadiosGridReady().then(function () {
                var idleTimeout = isMobileGlobe ? 8000 : 5500;
                var fallbackMs = isMobileGlobe ? 3200 : 2400;
                if (typeof window.requestIdleCallback === 'function') {
                    window.requestIdleCallback(start, { timeout: idleTimeout });
                } else {
                    setTimeout(start, fallbackMs);
                }
            });
        };

        if (document.readyState === 'complete') {
            runDeferred();
        } else {
            window.addEventListener('load', runDeferred, { once: true });
        }

        if (hero) {
            var eager = function () {
                hero.removeEventListener('pointerenter', eager);
                hero.removeEventListener('touchstart', eager);
                start();
            };
            hero.addEventListener('pointerenter', eager, { once: true, passive: true });
            hero.addEventListener('touchstart', eager, { once: true, passive: true });
        }
    }

    function init() {
        clearStaleThreeBeforeGlobe();
        loadScript(GLOBE_GL_URL).then(function () {
            try {
                window.dispatchEvent(new CustomEvent('rp-globe-three-ready'));
            } catch (e) { /* noop */ }
            return Promise.all([
                fetchJson(ENDPOINT_GLOBE + '?zoom=' + FLAT_FEED_ZOOM),
                loadLowResGlobeTexture()
            ]);
        }).then(function (results) {
            var data = results[0];
            var lowTex = results[1];
            if (!data || !data.success || !Array.isArray(data.clusters)) {
                throw new Error('invalid_globe_payload');
            }
            userCoord = data.user || null;
            showUserInfo(userCoord);
            renderGlobe(data.clusters, lowTex);
        }).catch(function (err) {
            hideGlobeLoading();
            setUserInfoLoading(false);
            if (userInfoEl) userInfoEl.hidden = true;
            if (window.console && console.warn) console.warn('rp-globe init failed:', err);
        });
    }

    function loadLowResGlobeTexture() {
        if (lowResBlobUrl) {
            return Promise.resolve({ blobUrl: lowResBlobUrl, appliedPx: 2048 });
        }
        return fetch(GLOBE_IMAGE_URL_LOW, { credentials: 'same-origin' })
            .then(function (r) {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.blob();
            })
            .then(function (rawBlob) {
                var blob = (rawBlob.type && rawBlob.type.indexOf('image/') === 0)
                    ? rawBlob
                    : new Blob([rawBlob], { type: 'image/jpeg' });
                lowResBlobUrl = URL.createObjectURL(blob);
                return { blobUrl: lowResBlobUrl, appliedPx: 2048 };
            })
            .catch(function () {
                return { blobUrl: GLOBE_IMAGE_URL_LOW_FALLBACK, appliedPx: 1600 };
            });
    }

    function applyLoadedHiResTexture(texture, appliedPx) {
        if (!texture || !globe) return;
        textureAppliedMaxPx = appliedPx || textureAppliedMaxPx;
        textureUpgraded = textureAppliedMaxPx >= 2048;
        if (texture.bitmap) {
            if (applyBitmapAsGlobeTexture(texture.bitmap)) return;
            scheduleBitmapGlobeTexture(texture.bitmap);
            return;
        }
        if (texture.blobUrl && typeof globe.globeImageUrl === 'function') {
            if (globeImageMode !== 'borders') currentPhotoUrl = texture.blobUrl;
            if (globeImageMode !== 'borders') globe.globeImageUrl(texture.blobUrl);
            scheduleDeferredTextureSharpening();
        }
    }

    /** Upgrade imediato da textura (modo descoberta / interação / zoom apertado). */
    function requestTextureUpgradeNow() {
        if (!globe) return;
        var targetW = getHiResTextureTargetSize();
        if (targetW < 2048) return;
        if (textureAppliedMaxPx >= targetW) {
            applyTextureSharpening();
            return;
        }
        loadHighResGlobeTexture(targetW).then(function (texture) {
            if (!texture || !globe) return;
            applyLoadedHiResTexture(texture, targetW);
        }).catch(function (err) {
            if (window.console && console.warn) {
                console.warn('rp-globe hi-res upgrade skipped:', err);
            }
        });
    }

    /** Sincroniza DPR + LOD de textura após zoom/pan (debounced). */
    function scheduleTextureQualitySync() {
        if (textureZoomSyncTimer) clearTimeout(textureZoomSyncTimer);
        textureZoomSyncTimer = setTimeout(function () {
            textureZoomSyncTimer = null;
            if (!globe) return;
            applyTextureSharpening();
            requestTextureUpgradeNow();
        }, 180);
    }

    /** Textura hi-res após interação no mapa (idle inicial mantém 2K leve). */
    function scheduleHiResTextureUpgrade() {
        if (textureAppliedMaxPx >= getHiResTextureTargetSize()) return;

        function runUpgrade() {
            requestTextureUpgradeNow();
        }

        function bindInteractionUpgrade() {
            if (hiResInteractionBound || !hero) return;
            hiResInteractionBound = true;
            var onEngage = function () {
                hero.removeEventListener('pointerdown', onEngage);
                hero.removeEventListener('wheel', onEngage);
                runUpgrade();
            };
            hero.addEventListener('pointerdown', onEngage, { passive: true });
            hero.addEventListener('wheel', onEngage, { passive: true });
        }

        bindInteractionUpgrade();

        if (globePerfTier === 'high') {
            setTimeout(function () {
                if (textureAppliedMaxPx < getHiResTextureTargetSize()) runUpgrade();
            }, GLOBE_HI_RES_INTERACTION_MS);
        }
    }

    function setGlobeRendering(active) {
        if (!globe) return;
        globeRenderPaused = !active;
        try {
            if (active && typeof globe.resumeAnimation === 'function') {
                globe.resumeAnimation();
            } else if (!active && typeof globe.pauseAnimation === 'function') {
                globe.pauseAnimation();
            }
        } catch (e) { /* noop */ }
    }

    function getCameraAltitude() {
        if (!globe) return 2;
        try {
            var pov = globe.pointOfView();
            return (pov && typeof pov.altitude === 'number') ? pov.altitude : 2;
        } catch (e) {
            return 2;
        }
    }

    /** Largura alvo da textura conforme zoom da câmara (mais perto → mais texels). */
    function getHiResTextureTargetSize() {
        // Mobile antes era totalmente excluído (return 0) — em zoom apertado a
        // textura 2K virava papa. Agora celulares sobem até 4K quando o zoom pede.
        var isLowEndMobile = isMobileGlobe && globePerfTier === 'low';
        var tierCap;
        if (isMobileGlobe) {
            tierCap = 4096;
        } else {
            tierCap = globePerfTier === 'high' ? GLOBE_HI_RES_MAX_PX_HIGH : GLOBE_HI_RES_MAX_PX;
        }
        var maxGpu = getMaxTextureSize();
        var alt = getCameraAltitude();
        var altCap = 2048;
        if (discoveryMode || alt < 1.4) altCap = 4096;
        if (alt <= 0.55) altCap = 5120;
        if (alt <= 0.2) altCap = 6144;
        if (alt <= 0.08) altCap = 8192;
        if (isLowEndMobile) altCap = Math.min(altCap, 4096);
        return Math.min(tierCap, altCap, maxGpu);
    }

    function getGlobeMaxDpr() {
        var dpr = window.devicePixelRatio || 1;
        var cap;
        if (isMobileGlobe) cap = 1;
        else if (globePerfTier === 'high') cap = 1.55;
        else cap = 1.3;
        if (discoveryMode) cap = Math.min(1.65, cap + 0.1);
        var alt = getCameraAltitude();
        if (alt <= 0.12) cap = Math.min(1.9, cap + 0.25);
        else if (alt <= 0.35) cap = Math.min(1.75, cap + 0.15);
        return Math.min(dpr, cap);
    }

    function getGlobeMaxAnisotropy(cap) {
        var alt = getCameraAltitude();
        var max = globePerfTier === 'high' ? 16 : 8;
        if (alt > 0.9) max = globePerfTier === 'high' ? 8 : 4;
        return Math.min(max, cap);
    }

    function shouldUseTextureCrossfade() {
        return globePerfTier === 'high' && !isMobileGlobe;
    }

    function shouldUseBumpMap() {
        // Bump de relevo degrada city lights em zoom apertado — desativado.
        return false;
    }

    /** Mapeia altitude da câmara → zoom level do endpoint /globe.php (1–5).
     *  Com histerese: usa thresholds diferentes para zoom-in vs zoom-out,
     *  evitando oscilação rápida entre níveis quando a câmara está perto
     *  de uma fronteira. */
    function altitudeToZoomLevel(alt, currentZoom) {
        var baseZoom = altitudeToZoomLevelBase(alt);
        if (currentZoom == null || baseZoom === currentZoom) return baseZoom;

        // Zooming out (número menor — vendo mais do globo)
        if (baseZoom < currentZoom) {
            var outThreshold = ZOOM_HYSTERESIS_ZOOM_OUT[currentZoom];
            if (outThreshold != null && alt < outThreshold) return currentZoom;
            return baseZoom;
        }
        // Zooming in (número maior — vendo mais detalhe)
        var inThreshold = ZOOM_HYSTERESIS_ZOOM_IN[currentZoom];
        if (inThreshold != null && alt > inThreshold) return currentZoom;
        return baseZoom;
    }

    function altitudeToZoomLevelBase(alt) {
        if (alt >= 2.8) return 1;   // ~57 clusters  (vista mundial extrema)
        if (alt >= 2.0) return 2;   // ~111         (continental)
        if (alt >= 1.0) return 3;   // ~246         (regional — alvo do view inicial 1.8)
        if (alt >= 0.4) return 4;   // ~810         (país/zoom apertado)
        return 5;                   // ~1915        (cidade — exige cuidado de perf)
    }

    /** Interpola continuamente o multiplicador de tamanho das bolinhas
     *  conforme a altitude da câmara. Evita o salto abrupto que ocorria
     *  com os valores discretos por zoom level. */
    function continuousSizeMultiplier(alt) {
        if (alt >= 2.8) return 4.0;
        if (alt >= 2.0) return 4.0 - (alt - 2.0) / 0.8 * 1.4;        // 4.0 → 2.6
        if (alt >= 1.0) return 2.6 - (alt - 1.0) / 1.0 * 1.15;       // 2.6 → 1.45
        if (alt >= 0.4) return 1.45 - (alt - 0.4) / 0.6 * 0.55;      // 1.45 → 0.9
        return 0.9 - (0.4 - alt) / 0.35 * 0.28;                       // 0.9 → 0.62 (alt min ~0.05)
    }

    // NOTA: a atualização contínua do tamanho das bolinhas durante o zoom
    // foi removida por questões de performance. O tamanho agora é interpolado
    // suavemente via continuousSizeMultiplier apenas na troca de clusters,
    // combinado com histerese para evitar saltos bruscos.

    /** Mapeia zoom 2D amplo para os LODs globais já usados pelo globo 3D.
     *  Mantém pontos distribuídos pelo planeta antes do drill-down local. */
    function globeZoomForRegionMapZoom(mapZoom) {
        if (mapZoom <= 2) return 1;
        if (mapZoom <= 3) return 2;
        if (mapZoom <= 4) return 3;
        if (mapZoom <= 5) return 4;
        if (mapZoom <= 6) return 5;
        return null;
    }

    function globeClustersToStations(clusters, zoom) {
        if (!Array.isArray(clusters)) return [];
        return clusters.filter(function (cluster) {
            return cluster && Number.isFinite(Number(cluster.lat))
                && Number.isFinite(Number(cluster.lng));
        }).map(function (cluster, index) {
            return {
                id: 'world-' + zoom + '-' + (cluster.id || index),
                lat: Number(cluster.lat),
                lng: Number(cluster.lng),
                count: Math.max(1, Number(cluster.count) || 1),
                title: cluster.title || 'Cluster de rádios',
                isGlobeCluster: true,
                globeZoom: zoom
            };
        });
    }

    // -- Modo flat estilo radio.garden ----------------------------------------
    // Abaixo desta altitude o globo "achata": câmara desce até quase a superfície,
    // controles limitados a orbitar (sem tilt), e o feed sobe para o LOD máximo
    // (zoom=5, ~1915 clusters = todas as cidades com rádio do nosso feed).
    var FLATTEN_ALTITUDE = 0.03;
    var FLAT_CAMERA_ALTITUDE = 0.022;
    var FLAT_FEED_ZOOM = 5;

    // -- Overlay vetorial (cortesia radio.garden) ------------------------------
    // Entre VECTOR_FADE_START e VECTOR_FADE_END a textura fotográfica perde a
    // guerra de resolução (8K esticado vira papa). Desenhamos contornos vetoriais
    // (Natural Earth local, nítido em qualquer zoom) por cima e escurecemos a
    // foto proporcionalmente — transição espaço → globo → mapa vetorial.
    var VECTOR_FADE_START = 0.45;
    var VECTOR_FADE_END = 0.12;
    var VECTOR_PHOTO_DIM_FLOOR = 0.35;

    function vectorOverlayStrengthForAltitude(alt) {
        if (!(alt >= VECTOR_FADE_END)) return 1;
        if (alt >= VECTOR_FADE_START) return 0;
        var t = (VECTOR_FADE_START - alt) / (VECTOR_FADE_START - VECTOR_FADE_END);
        return Math.max(0, Math.min(1, t));
    }

    function photoDimForAltitude(alt) {
        var vectorStrength = 1 - vectorOverlayStrengthForAltitude(alt);
        return VECTOR_PHOTO_DIM_FLOOR + (1 - VECTOR_PHOTO_DIM_FLOOR) * vectorStrength;
    }

    function globeZoomAltitudeFloor() {
        return FLAT_CAMERA_ALTITUDE;
    }

    function globeModeForAltitude(alt) {
        return alt <= FLATTEN_ALTITUDE ? 'flat' : '3d';
    }

    function globeFeedForMode(mode, currentZoom) {
        if (mode === 'flat') return FLAT_FEED_ZOOM;
        return currentZoom;
    }

    /** Raio em km a buscar no modal 2D consoante o zoom do globo no momento
     *  do click. Células maiores → raio maior para cobrir a área toda. */
    function regionRadiusForZoom(zoom) {
        return ({ 1: 1500, 2: 800, 3: 400, 4: 160, 5: 80 })[zoom] || 200;
    }

    /** Cor do anel "você está aqui" (função estável — evita alocar closures
     *  a cada frame no accessor do globe.gl). */
    function userRingStrokeColor(t) {
        var alpha = 0.85 * Math.pow(1 - t, 1.5);
        return 'rgba(34, 211, 238, ' + alpha + ')';
    }

    /** Accessor do globe.gl para o anel do usuário: devolve a função de cor
     *  radial (t → rgba). O accessor recebe o datum do anel; a interpolação
     *  radial é a função estável `userRingStrokeColor`. */
    function userRingColorAccessor() {
        return userRingStrokeColor;
    }

    /** Brilho/saturação por zoom: pontos mais vivos que a textura noturna do globo. */
    function pointGlowForZoom(zoom) {
        return ({
            1: { saturation: 1.24, lightness: 1.34, lift: 12 },
            2: { saturation: 1.18, lightness: 1.26, lift: 10 },
            3: { saturation: 1.12, lightness: 1.18, lift: 8 },
            4: { saturation: 1.08, lightness: 1.12, lift: 6 },
            5: { saturation: 1.04, lightness: 1.06, lift: 4 }
        })[zoom] || { saturation: 1.12, lightness: 1.18, lift: 8 };
    }

    function clustersToPoints(clusters, zoomLevel) {
        var zoom = zoomLevel || currentZoomLevel;
        var maxCount = clusters.reduce(function (m, c) { return Math.max(m, c.count || 0); }, 1);
        return clusters.map(function (c) {
            var t = Math.log10((c.count || 0) + 1) / Math.log10(maxCount + 1);
            var baseRadius = (0.2 + 0.32 * t);
            var baseAltitude = GLOBE_POINT_ALTITUDE;
            return {
                lat: c.lat,
                lng: c.lng,
                baseLat: c.lat,
                baseLng: c.lng,
                count: c.count,
                title: c.title,
                // Leve elevação + disco achatado para destacar da textura.
                altitude: baseAltitude,
                baseAltitude: baseAltitude,
                color: colorForCount(c.count || 0, maxCount, zoom),
                radius: baseRadius,
                baseRadius: baseRadius
            };
        });
    }

    function optimizeGlobeTextureMap(tex, renderer) {
        if (!tex) return;
        try {
            var THREE = window.THREE;
            if (THREE) {
                tex.generateMipmaps = true;
                if (THREE.LinearMipmapLinearFilter != null) {
                    tex.minFilter = THREE.LinearMipmapLinearFilter;
                }
                if (THREE.LinearFilter != null) {
                    tex.magFilter = THREE.LinearFilter;
                }
            }
            if (renderer && renderer.capabilities && renderer.capabilities.getMaxAnisotropy && tex.anisotropy != null) {
                tex.anisotropy = getGlobeMaxAnisotropy(renderer.capabilities.getMaxAnisotropy());
            }
            tex.needsUpdate = true;
        } catch (e) { /* noop */ }
    }

    /** Aplica anisotropia máxima do GPU e bumpScale ao material atual do
     *  globo. Idempotente — pode ser chamada várias vezes (por ex. após
     *  trocar a textura para a versão hi-res). */
    function applyTextureSharpening() {
        if (!globe) return;
        try {
            var renderer = (typeof globe.renderer === 'function') ? globe.renderer() : null;
            if (renderer && typeof renderer.setPixelRatio === 'function') {
                renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, getGlobeMaxDpr()));
            }
            var mat = (typeof globe.globeMaterial === 'function') ? globe.globeMaterial() : null;
            if (mat && renderer && renderer.capabilities && renderer.capabilities.getMaxAnisotropy) {
                if (mat.map) optimizeGlobeTextureMap(mat.map, renderer);
                if (mat.bumpMap) {
                    optimizeGlobeTextureMap(mat.bumpMap, renderer);
                    if (typeof mat.bumpScale !== 'undefined') mat.bumpScale = 0;
                }
            }
        } catch (e) { /* sem sharpening extra, segue a vida */ }
    }

    /** Copia filtros/encoding da textura atual para outra instância. */
    function copyGlobeTextureSettings(srcTex, destTex) {
        if (srcTex.colorSpace) destTex.colorSpace = srcTex.colorSpace;
        if (srcTex.encoding != null) destTex.encoding = srcTex.encoding;
        if (srcTex.wrapS != null) destTex.wrapS = srcTex.wrapS;
        if (srcTex.wrapT != null) destTex.wrapT = srcTex.wrapT;
        destTex.flipY = false;
        destTex.generateMipmaps = true;
        try {
            var THREE = window.THREE;
            if (THREE && THREE.LinearMipmapLinearFilter != null) {
                destTex.minFilter = THREE.LinearMipmapLinearFilter;
                destTex.magFilter = THREE.LinearFilter;
            } else if (srcTex.minFilter != null) {
                destTex.minFilter = srcTex.minFilter;
                destTex.magFilter = srcTex.magFilter;
            }
        } catch (e) {
            if (srcTex.minFilter != null) destTex.minFilter = srcTex.minFilter;
            if (srcTex.magFilter != null) destTex.magFilter = srcTex.magFilter;
        }
    }

    /** Detecta sampler e UV corretos do three.js embutido no globe.gl (r170+ usa vMapUv). */
    function resolveGlobeShaderSampleFn(fragmentShader) {
        var src = fragmentShader || '';
        return src.indexOf('texture2D') !== -1 ? 'texture2D' : 'texture';
    }

    function resolveGlobeShaderUvVar(shader, mat) {
        var defines = shader.defines || (mat && mat.defines) || {};
        if (defines.MAP_UV !== undefined) return 'vMapUv';
        var frag = (shader && shader.fragmentShader) || '';
        var vert = (shader && shader.vertexShader) || '';
        if (frag.indexOf('vMapUv') !== -1 || vert.indexOf('vMapUv') !== -1) return 'vMapUv';
        if (frag.indexOf('MAP_UV') !== -1 || vert.indexOf('MAP_UV') !== -1) return 'vMapUv';
        if (resolveGlobeShaderSampleFn(frag) === 'texture') return 'vMapUv';
        return 'vUv';
    }

    function resetGlobeMaterialCrossfadeHook(mat) {
        if (!mat || !mat.userData.rpGlobeCrossfadeHooked) return;
        cancelGlobeTextureCrossfade();
        var uniforms = mat.userData.rpGlobeCrossfadeUniforms;
        if (uniforms) {
            uniforms.uPrevMap.value = null;
            uniforms.uTextureMix.value = 1;
        }
        delete mat.userData.rpGlobeCrossfadeHooked;
        delete mat.userData.rpGlobeCrossfadeUniforms;
        delete mat.userData.rpGlobeCrossfadeSupported;
        delete mat.userData.rpGlobeCrossfadeUnsupported;
        delete mat.onBeforeCompile;
        delete mat.customProgramCacheKey;
        mat.needsUpdate = true;
    }

    /** Injeta mix(uPrevMap, map, uTextureMix) no fragment shader do material do globo. */
    function hookGlobeMaterialForTextureCrossfade(mat) {
        if (!mat || mat.userData.rpGlobeCrossfadeHooked) return;
        mat.userData.rpGlobeCrossfadeHooked = true;
        mat.userData.rpGlobeCrossfadeUniforms = {
            uPrevMap: { value: null },
            uTextureMix: { value: 1 }
        };

        var prevCacheKey = mat.customProgramCacheKey;
        mat.customProgramCacheKey = function () {
            var base = prevCacheKey ? prevCacheKey.call(this) : '';
            return base + '_rpGlobeXfade';
        };

        mat.onBeforeCompile = function (shader) {
            var uniforms = mat.userData.rpGlobeCrossfadeUniforms;
            shader.uniforms.uPrevMap = uniforms.uPrevMap;
            shader.uniforms.uTextureMix = uniforms.uTextureMix;

            shader.fragmentShader = shader.fragmentShader.replace(
                '#include <common>',
                '#include <common>\nuniform sampler2D uPrevMap;\nuniform float uTextureMix;'
            );

            var sampleFn = resolveGlobeShaderSampleFn(shader.fragmentShader);
            var uvVar = resolveGlobeShaderUvVar(shader, mat);
            var mapFragmentReplacement =
                '#ifdef USE_MAP\n' +
                '  vec4 rpPrevTexel = ' + sampleFn + '( uPrevMap, ' + uvVar + ' );\n' +
                '  vec4 rpNewTexel = ' + sampleFn + '( map, ' + uvVar + ' );\n' +
                '  #ifdef DECODE_VIDEO_TEXTURE\n' +
                '    rpPrevTexel = vec4( mix( pow( rpPrevTexel.rgb * rpPrevTexel.a, vec3( 2.2 ) ), rpPrevTexel.rgb, rpPrevTexel.a ), rpPrevTexel.a );\n' +
                '    rpNewTexel = vec4( mix( pow( rpNewTexel.rgb * rpNewTexel.a, vec3( 2.2 ) ), rpNewTexel.rgb, rpNewTexel.a ), rpNewTexel.a );\n' +
                '  #endif\n' +
                '  diffuseColor *= mix( rpPrevTexel, rpNewTexel, uTextureMix );\n' +
                '#endif';

            if (shader.fragmentShader.indexOf('#include <map_fragment>') !== -1) {
                shader.fragmentShader = shader.fragmentShader.replace(
                    '#include <map_fragment>',
                    mapFragmentReplacement
                );
                mat.userData.rpGlobeCrossfadeSupported = true;
            } else {
                mat.userData.rpGlobeCrossfadeUnsupported = true;
            }
        };
    }

    function cancelGlobeTextureCrossfade() {
        if (textureCrossfadeRaf) {
            cancelAnimationFrame(textureCrossfadeRaf);
            textureCrossfadeRaf = null;
        }
    }

    /** Crossfade 2K → 8K no shader (desktop); instant swap se reduced-motion. */
    function crossfadeGlobeTexture(mat, oldTex, newTex, onComplete) {
        hookGlobeMaterialForTextureCrossfade(mat);
        var uniforms = mat.userData.rpGlobeCrossfadeUniforms;

        cancelGlobeTextureCrossfade();

        uniforms.uPrevMap.value = oldTex;
        uniforms.uTextureMix.value = 0;
        mat.map = newTex;
        mat.needsUpdate = true;

        try {
            var renderer = globe && typeof globe.renderer === 'function' ? globe.renderer() : null;
            var scene = globe && typeof globe.scene === 'function' ? globe.scene() : null;
            var camera = globe && typeof globe.camera === 'function' ? globe.camera() : null;
            if (renderer && scene && camera && typeof renderer.compile === 'function') {
                renderer.compile(scene, camera);
            }
        } catch (compileErr) { /* noop */ }

        requestAnimationFrame(function () {
            if (mat.userData.rpGlobeCrossfadeUnsupported) {
                swapGlobeTextureInstant(mat, newTex, oldTex);
                return;
            }
            if (!mat.userData.rpGlobeCrossfadeSupported) {
                swapGlobeTextureInstant(mat, newTex, oldTex);
                return;
            }
            beginGlobeTextureCrossfadeAnimation(mat, oldTex, newTex, onComplete);
        });
    }

    function beginGlobeTextureCrossfadeAnimation(mat, oldTex, newTex, onComplete) {
        var uniforms = mat.userData.rpGlobeCrossfadeUniforms;
        var start = (typeof performance !== 'undefined' && performance.now)
            ? performance.now()
            : Date.now();
        var duration = GLOBE_TEXTURE_CROSSFADE_MS;

        function step(now) {
            if (!mat || mat.map !== newTex) {
                textureCrossfadeRaf = null;
                return;
            }
            var t = Math.min(1, (now - start) / duration);
            var eased = 1 - Math.pow(1 - t, 2);
            uniforms.uTextureMix.value = eased;

            if (t < 1) {
                textureCrossfadeRaf = requestAnimationFrame(step);
                return;
            }

            textureCrossfadeRaf = null;
            uniforms.uTextureMix.value = 1;
            uniforms.uPrevMap.value = null;
            if (oldTex && typeof oldTex.dispose === 'function') oldTex.dispose();
            resetGlobeMaterialCrossfadeHook(mat);
            mat.map = newTex;
            mat.needsUpdate = true;
            if (typeof onComplete === 'function') onComplete();
        }

        textureCrossfadeRaf = requestAnimationFrame(step);
    }

    function swapGlobeTextureInstant(mat, newTex, oldTex) {
        resetGlobeMaterialCrossfadeHook(mat);
        mat.map = newTex;
        mat.needsUpdate = true;
        if (oldTex && typeof oldTex.dispose === 'function') oldTex.dispose();
        scheduleDeferredTextureSharpening();
    }

    /** Adia sharpening/mipmaps para não competir com o primeiro paint e a animação da câmara. */
    function scheduleDeferredTextureSharpening() {
        if (textureSharpenTimer) clearTimeout(textureSharpenTimer);
        textureSharpenTimer = setTimeout(function () {
            textureSharpenTimer = null;
            var run = function () { applyTextureSharpening(); };
            if (typeof window.requestIdleCallback === 'function') {
                window.requestIdleCallback(run, { timeout: 2500 });
            } else {
                run();
            }
        }, 450);
    }

    /** Aplica um ImageBitmap pré-decodificado direto no material do globo.
     *  Desktop: crossfade shader 2K→8K; mobile/reduced-motion: swap instantâneo. */
    function applyBitmapAsGlobeTexture(bitmap) {
        if (!globe || !bitmap) return false;
        try {
            var mat = (typeof globe.globeMaterial === 'function') ? globe.globeMaterial() : null;
            if (!mat || !mat.map || !mat.map.constructor) return false;
            var TextureCtor = mat.map.constructor;
            var newTex = new TextureCtor(bitmap);
            copyGlobeTextureSettings(mat.map, newTex);
            newTex.needsUpdate = true;

            var oldMap = mat.map;
            var useCrossfade = shouldUseTextureCrossfade() && oldMap && oldMap !== newTex;

            if (useCrossfade) {
                crossfadeGlobeTexture(mat, oldMap, newTex, function () {
                    scheduleDeferredTextureSharpening();
                });
            } else {
                swapGlobeTextureInstant(mat, newTex, oldMap);
            }
            if (bitmap && bitmap.width) {
                textureAppliedMaxPx = Math.max(textureAppliedMaxPx, bitmap.width);
                textureUpgraded = textureAppliedMaxPx >= 2048;
            }
            return true;
        } catch (e) {
            if (window.console && console.warn) console.warn('applyBitmapAsGlobeTexture failed:', e);
            return false;
        }
    }

    /** Limite de textura do GPU (query única com cache — criar WebGL contexts
     *  repetidamente causa 'Too many active WebGL contexts' no browser). */
    var _cachedMaxTextureSize = null;
    function getMaxTextureSize() {
        if (_cachedMaxTextureSize !== null) return _cachedMaxTextureSize;
        try {
            var probe = document.createElement('canvas');
            var gl = probe.getContext('webgl') || probe.getContext('experimental-webgl');
            if (gl) {
                _cachedMaxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE) || 8192;
                // Libera o contexto de probe imediatamente para não acumular.
                var loseContextExt = gl.getExtension('WEBGL_lose_context');
                if (loseContextExt) loseContextExt.loseContext();
                probe = null;
                return _cachedMaxTextureSize;
            }
        } catch (e) { /* noop */ }
        _cachedMaxTextureSize = 8192;
        return _cachedMaxTextureSize;
    }

    function fetchHiResSourceBlob() {
        if (hiResSourceBlob) return Promise.resolve(hiResSourceBlob);
        if (hiResFetchPromise) return hiResFetchPromise;
        hiResFetchPromise = fetch(GLOBE_IMAGE_URL_HIGH, { credentials: 'same-origin' })
            .then(function (r) {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.blob();
            })
            .then(function (rawBlob) {
                hiResSourceBlob = (rawBlob.type && rawBlob.type.indexOf('image/') === 0)
                    ? rawBlob
                    : new Blob([rawBlob], { type: 'image/jpeg' });
                return hiResSourceBlob;
            })
            .catch(function (err) {
                hiResFetchPromise = null;
                throw err;
            });
        return hiResFetchPromise;
    }

    function decodeHiResBlob(blob, targetW) {
        targetW = Math.min(targetW, getMaxTextureSize());
        var targetH = Math.floor(targetW / 2);
        var resizeQuality = globePerfTier === 'high' ? 'high' : 'medium';
        var blobUrl = URL.createObjectURL(blob);

        if (typeof window.createImageBitmap !== 'function') {
            return Promise.resolve({ blobUrl: blobUrl });
        }

        return window.createImageBitmap(blob, {
            resizeWidth: targetW,
            resizeHeight: targetH,
            resizeQuality: resizeQuality,
            imageOrientation: 'flipY'
        }).catch(function () {
            return window.createImageBitmap(blob, { imageOrientation: 'flipY' })
                .catch(function () {
                    return window.createImageBitmap(blob);
                });
        }).then(function (bitmap) {
            return { bitmap: bitmap, blobUrl: blobUrl, appliedPx: targetW };
        });
    }

    /** Baixa (uma vez) e decodifica a textura hi-res no tamanho pedido. */
    function loadHighResGlobeTexture(requestedW) {
        if (typeof document.hidden === 'boolean' && document.hidden) {
            return new Promise(function (resolve, reject) {
                var onVis = function () {
                    if (!document.hidden) {
                        document.removeEventListener('visibilitychange', onVis);
                        loadHighResGlobeTexture(requestedW).then(resolve, reject);
                    }
                };
                document.addEventListener('visibilitychange', onVis);
            });
        }

        var targetW = requestedW || getHiResTextureTargetSize();
        if (targetW < 2048) {
            return Promise.reject(new Error('hi_res_disabled'));
        }

        return fetchHiResSourceBlob().then(function (blob) {
            return decodeHiResBlob(blob, targetW);
        });
    }

    /** Troca a textura do globo por um bitmap já decodificado, quando o
     *  material do three-globe estiver pronto (evita ficar no placeholder). */
    function scheduleBitmapGlobeTexture(bitmap) {
        if (!bitmap) return;

        var attempts = 0;
        var tryApply = function () {
            if (!globe) return;
            if (applyBitmapAsGlobeTexture(bitmap)) return;
            attempts += 1;
            if (attempts < 24) {
                requestAnimationFrame(tryApply);
            }
        };

        requestAnimationFrame(tryApply);
    }

    function renderGlobe(clusters, lowTex) {
        if (typeof window.Globe !== 'function') return;

        // Cacheia o set inicial para que se o utilizador zoom-out e voltar a
        // zoom=3 não precise re-fetchar — vem direto do cache em memória.
        clustersCache[currentZoomLevel] = clusters;
        var points = clustersToPoints(clusters);
        globePoints = points;
        hoveredGlobePoint = null;

        actuallyCreateGlobe(points, null, lowTex);
        scheduleHiResTextureUpgrade();
    }

    function actuallyCreateGlobe(points, hiResTexture, lowTex) {
        var globeImage = GLOBE_IMAGE_URL_LOW_FALLBACK;
        var pendingBitmap = null;

        if (lowTex && lowTex.blobUrl) {
            globeImage = lowTex.blobUrl;
            textureAppliedMaxPx = lowTex.appliedPx || 2048;
        }

        if (hiResTexture && hiResTexture.blobUrl) {
            globeImage = hiResTexture.blobUrl;
            textureUpgraded = true;
            textureAppliedMaxPx = hiResTexture.appliedPx || GLOBE_HI_RES_MAX_PX;
            if (hiResTexture.bitmap) pendingBitmap = hiResTexture.bitmap;
        }

        globe = window.Globe()
            (canvas)
            .globeImageUrl(globeImage)
            .backgroundColor('rgba(0,0,0,0)')
            .pointLabel('')
            .lineHoverPrecision(0.45);

        if (shouldUseBumpMap()) {
            globe.bumpImageUrl(GLOBE_BUMP_URL);
        }

        if (pendingBitmap) {
            scheduleBitmapGlobeTexture(pendingBitmap);
        }

        if (!isMobileGlobe) {
            scheduleDeferredTextureSharpening();
        }

        setupGlobeVisibilityPause();
        buildSpriteLayer();

        var controls = globe.controls();
        controls.autoRotate = true;
        controls.autoRotateSpeed = 0.6;
        controls.enableZoom = true;
        controls.enablePan = false;
        controls.minDistance = 101; // raio do globo = 100; desce até o modo flat
        controls.maxDistance = 1500;

        controls.addEventListener('start', function () {
            controls.autoRotate = false;
            updateRotateButtonState();
            if (!discoveryMode) enterDiscoveryMode();
        });
        // Modo flat precisa ser avaliado também durante tweens programáticos:
        // pointOfView() animado não dispara start/end dos controls.
        controls.addEventListener('change', syncGlobeMode);
        setInterval(function () {
            syncGlobeMode();
            applyVectorOverlayFrame(false);
            updateSpriteScale();
        }, 400);
        controls.addEventListener('end', scheduleTextureQualitySync);
        // LOD dos clusters: ao terminar o movimento, verifica se a altitude
        // cruzou o limiar de zoom level e troca os clusters se sim.
        controls.addEventListener('end', checkZoomLevel);

        // Câmara inicial + ring no utilizador
        if (userCoord && typeof userCoord.lat === 'number' && typeof userCoord.lng === 'number') {
            globe.pointOfView({ lat: userCoord.lat, lng: userCoord.lng, altitude: 1.8 }, 1500);
            globe.ringsData([{ lat: userCoord.lat, lng: userCoord.lng }])
                .ringColor(userRingColorAccessor)
                .ringResolution(isMobileGlobe ? 16 : 28)
                .ringMaxRadius(3.5)
                .ringPropagationSpeed(1.6)
                .ringRepeatPeriod(2200)
                .ringAltitude(0.001);
        } else {
            globe.pointOfView({ lat: -15, lng: -55, altitude: 2.2 }, 0);
        }

        resize();
        window.addEventListener('resize', debounce(function () {
            updateDiscoveryGlobeInset();
            resize();
        }, 200));

        canvas.classList.add('is-ready');
        if (hero) hero.classList.add('has-globe');
        hideGlobeLoading();
        injectGlobeControls();
        syncGlobeMode();
    }

    /** Pausa o loop WebGL quando o hero sai da viewport (scroll para o grid). */
    function setupGlobeVisibilityPause() {
        if (!hero || typeof window.IntersectionObserver !== 'function') return;
        var visIo = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
                var visible = e.isIntersecting && e.intersectionRatio >= 0.15;
                if (visible && !document.hidden) {
                    setGlobeRendering(true);
                } else {
                    setGlobeRendering(false);
                }
            });
        }, { threshold: [0, 0.15, 0.35] });
        visIo.observe(hero);
        document.addEventListener('visibilitychange', function () {
            if (document.hidden) {
                setGlobeRendering(false);
            } else if (hero) {
                var rect = hero.getBoundingClientRect();
                if (rect.bottom > 0 && rect.top < window.innerHeight) {
                    setGlobeRendering(true);
                }
            }
        });
    }

    function injectGlobeControls() {
        if (!hero || hero.querySelector('.rp-globe-controls')) return;
        var wrap = document.createElement('div');
        wrap.className = 'rp-globe-controls';
        wrap.setAttribute('aria-label', 'Controles do globo');
        wrap.innerHTML = ''
            + '<div class="rp-globe-zoom" role="group" aria-label="Zoom">'
            +   '<button type="button" class="rp-globe-ctrl rp-globe-ctrl-zoom" data-action="zoom-in" aria-label="Aproximar">'
            +     '<i class="fas fa-plus" aria-hidden="true"></i></button>'
            +   '<span class="rp-globe-zoom-divider" aria-hidden="true"></span>'
            +   '<button type="button" class="rp-globe-ctrl rp-globe-ctrl-zoom" data-action="zoom-out" aria-label="Afastar">'
            +     '<i class="fas fa-minus" aria-hidden="true"></i></button>'
            + '</div>'
            + '<button type="button" class="rp-globe-ctrl rp-globe-ctrl-rotate" data-action="toggle-rotate" aria-label="Alternar rotação automática" aria-pressed="false">'
            +   '<i class="fas fa-rotate" aria-hidden="true"></i></button>'
            + '<button type="button" class="rp-globe-ctrl rp-globe-ctrl-unfocus" data-action="unfocus" aria-label="Voltar à vista geral">'
            +   '<i class="fas fa-globe" aria-hidden="true"></i></button>';
        hero.appendChild(wrap);

        wrap.addEventListener('click', function (ev) {
            var btn = ev.target.closest && ev.target.closest('.rp-globe-ctrl');
            if (!btn) return;
            ev.stopPropagation();
            var action = btn.getAttribute('data-action');
            if (action === 'zoom-in') zoomBy(0.65);
            else if (action === 'zoom-out') zoomBy(1.55);
            else if (action === 'toggle-rotate') toggleAutoRotate();
            else if (action === 'unfocus') unfocus();
        });

        // Estado inicial do botão de rotação reflete controls.autoRotate.
        updateRotateButtonState();
    }

    function toggleAutoRotate() {
        if (!globe) return;
        var c = globe.controls();
        c.autoRotate = !c.autoRotate;
        updateRotateButtonState();
    }

    function updateRotateButtonState() {
        if (!hero || !globe) return;
        var btn = hero.querySelector('[data-action="toggle-rotate"]');
        if (!btn) return;
        var isOn = !!globe.controls().autoRotate;
        btn.classList.toggle('is-active', isOn);
        btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        btn.setAttribute('aria-label', isOn ? 'Parar rotação automática' : 'Iniciar rotação automática');
    }

    function zoomBy(factor) {
        if (!globe) return;
        var pov = globe.pointOfView();
        var nextAlt = Math.max(globeZoomAltitudeFloor(), pov.altitude * factor);
        globe.pointOfView({ lat: pov.lat, lng: pov.lng, altitude: nextAlt }, 600);
        setTimeout(function () {
            checkZoomLevel();
            scheduleTextureQualitySync();
        }, 700);
    }

    function unfocus() {
        if (!globe) return;
        var lat = (userCoord && typeof userCoord.lat === 'number') ? userCoord.lat : -15;
        var lng = (userCoord && typeof userCoord.lng === 'number') ? userCoord.lng : -55;
        globe.pointOfView({ lat: lat, lng: lng, altitude: 2.0 }, 900);
        setTimeout(checkZoomLevel, 950);
    }

    /** Verifica se a altitude actual mudou o zoom level e dispara fetch
     *  (debounced 500 ms) para evitar requests durante zoom contínuo. */
    function checkZoomLevel() {
        // Arquitetura radio.garden: um único dataset completo (zoom=5, ~1915 pontos)
        // carregado no boot; o tamanho do sprite reage à altitude via uScale no shader.
        if (!globe) return;
        syncGlobeMode();
        updateSpriteScale();
    }

    /** Ajusta uScale conforme a altitude: perto = pontos menores (mais detalhe visível). */
    function updateSpriteScale() {
        if (!spriteUniforms) return;
        var alt = getCameraAltitude();
        // radio.garden: LONGE = pontos pequenos (planeta inteiro legível);
        // PERTO = pontos ligeiramente maiores para preencher a visão da cidade.
        // altitude 2.2 (longe) -> 0.28 ; altitude 0.05 (perto) -> 0.6
        var t = Math.max(0, Math.min(1, (alt - 0.05) / (2.2 - 0.05)));
        spriteUniforms.uScale.value = (window.innerHeight || 900) * 0.5 * (0.6 - 0.32 * t);
    }

    function loadClustersForZoom(zoomLevel) {
        if (clustersCache[zoomLevel]) {
            currentZoomLevel = zoomLevel;
            applyClusters(clustersCache[zoomLevel]);
            return;
        }
        fetchJson(ENDPOINT_GLOBE + '?zoom=' + zoomLevel).then(function (data) {
            if (!data || !data.success || !Array.isArray(data.clusters)) return;
            clustersCache[zoomLevel] = data.clusters;
            currentZoomLevel = zoomLevel;
            applyClusters(data.clusters);
        }).catch(function () { /* silencioso — mantém clusters anteriores */ });
    }

    /** Busca o feed completo (zoom=5) usado no modo flat, uma única vez. */
    function ensureFlatFeed() {
        if (flatFeedLoaded || flatFeedLoading) return;
        flatFeedLoading = true;
        fetchJson(ENDPOINT_GLOBE + '?zoom=' + FLAT_FEED_ZOOM).then(function (data) {
            flatFeedLoading = false;
            if (!data || !data.success || !Array.isArray(data.clusters)) return;
            clustersCache[FLAT_FEED_ZOOM] = data.clusters;
            flatFeedLoaded = true;
            // Se o modo flat já foi ativado enquanto buscava, aplica agora.
            if (globeMode === 'flat' && globe) applyClusters(data.clusters);
        }).catch(function () {
            flatFeedLoading = false;
        });
    }

    /** Alterna 3D ↔ flat com transição contínua da câmara (sem modal 2D). */
    function syncGlobeMode() {
        if (!globe) return;
        var alt = globe.pointOfView().altitude;
        var mode = globeModeForAltitude(alt);

        if (mode === 'flat') {
            // Câmara deixa de girar o planeta e passa a orbitar em nível quase tangente.
            globe.controls().autoRotate = false;
            updateRotateButtonState();
            if (globeMode !== 'flat') {
                globeMode = 'flat';
                if (canvas) canvas.classList.add('is-flat');
                ensureFlatFeed();
            }
            return;
        }

        if (globeMode !== '3d') {
            globeMode = '3d';
            if (canvas) canvas.classList.remove('is-flat');
            checkZoomLevel();
        }
    }

    function applyClusters(clusters) {
        if (!globe) return;
        hoveredGlobePoint = null;
        if (canvas) canvas.style.cursor = '';
        globePoints = clustersToPoints(clusters, currentZoomLevel);
        resetGlobePointLayout();
        rebuildSpriteGeometry();
    }

    /** Recria os buffers de sprites após troca de LOD. */
    function rebuildSpriteGeometry() {
        if (!spriteLayerBuilt) { buildSpriteLayer(); return; }
        var THREE = getTHREE();
        if (!THREE || !spriteLayerGroup) return;
        var positions = new Float32Array(globePoints.length * 3);
        var colors = new Float32Array(globePoints.length * 3);
        var sizes = new Float32Array(globePoints.length);
        var R = 100.35;
        for (var i = 0; i < globePoints.length; i++) {
            var p = globePoints[i];
            var v = latLngToSceneVec3(p.lat, p.lng, R);
            positions[i * 3] = v.x; positions[i * 3 + 1] = v.y; positions[i * 3 + 2] = v.z;
            var c = new THREE.Color(p.color);
            colors[i * 3] = c.r; colors[i * 3 + 1] = c.g; colors[i * 3 + 2] = c.b;
            sizes[i] = POINT_BASE_SIZE * (0.65 + 0.7 * Math.min(1, (p.count || 1) / 500)); // tamanho por densidade
        }
        var g = spriteLayerGroup.geometry;
        g.getAttribute('position').copyArray(positions);
        g.getAttribute('position').needsUpdate = true;
        g.getAttribute('aColor').copyArray(colors);
        g.getAttribute('aColor').needsUpdate = true;
        var sizeAttr = g.getAttribute('aSize');
        sizeAttr.copyArray(sizes);
        sizeAttr.needsUpdate = true;
        g.computeBoundingSphere();
    }

    function resize(options) {
        options = options || {};
        if (!globe || !canvas) return;
        var rect = canvas.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) {
            globe.width(rect.width).height(rect.height);
            if (!options.skipSharpen) applyTextureSharpening();
        }
    }

    function resizeIfNeeded(options) {
        options = options || {};
        if (!globe || !canvas) return;
        var rect = canvas.getBoundingClientRect();
        var scene = canvas.querySelector('.scene-container');
        var sceneRect = scene ? scene.getBoundingClientRect() : null;
        var threshold = options.threshold || 2;

        if (sceneRect
            && Math.abs(sceneRect.width - rect.width) <= threshold
            && Math.abs(sceneRect.height - rect.height) <= threshold) {
            return;
        }

        resize(options);
    }

    function onClusterClick(point) {
        if (!point) return;
        openRegionMap(point);
    }

    // -- Region map (Leaflet) ------------------------------------------------

    function ensureRegionOverlay() {
        if (regionOverlay) return regionOverlay;
        var existing = document.getElementById('rp-region-map-overlay');
        if (existing) { regionOverlay = existing; return existing; }

        var ov = document.createElement('div');
        ov.id = 'rp-region-map-overlay';
        ov.className = 'rp-region-map-overlay';
        ov.hidden = true;
        ov.setAttribute('role', 'dialog');
        ov.setAttribute('aria-label', 'Mapa da região');
        ov.innerHTML = ''
            + '<div class="rp-region-map-card">'
            +   '<button class="rp-region-map-close" type="button" aria-label="Fechar mapa">&times;</button>'
            +   '<div class="rp-region-map-header">'
            +     '<h3 class="rp-region-map-title">Rádios da região</h3>'
            +     '<p class="rp-region-map-meta"></p>'
            +   '</div>'
            +   '<div class="rp-region-map-body">'
            +     '<div id="rp-region-map" class="rp-region-map-canvas"></div>'
            +     '<div class="rp-region-map-loading" id="rp-region-map-loading">'
            +       '<span class="rp-region-map-spinner" aria-hidden="true"></span>'
            +       '<span>Carregando rádios da região…</span>'
            +     '</div>'
            +   '</div>'
            + '</div>';
        document.body.appendChild(ov);
        regionOverlay = ov;

        ov.addEventListener('click', function (ev) {
            if (ev.target === ov) closeRegionMap();
            if (ev.target.closest && ev.target.closest('.rp-region-map-close')) closeRegionMap();
        });
        document.addEventListener('keydown', function (ev) {
            if (ev.key === 'Escape' && !ov.hidden) closeRegionMap();
        });
        return ov;
    }

    // -- Transição globo → mapa 2D (radio.garden) ------------------------------
    // Uma textura única do planeta nunca tem resolução para o close zoom (8K no
    // mundo inteiro ≈ 0.09°/px — esticada vira papa), e o swap de textura 8K
    // congela celulares. O radio.garden não resolve isso com textura: troca para
    // um mapa vetorial real. Nós JÁ temos um — o Leaflet com GeoJSON local,
    // nítido em qualquer zoom e barato (canvas 2D). Ao descer abaixo do limiar,
    // abrimos automaticamente esse mapa centrado na câmara; fechar volta ao globo.
    var AUTO_MAP_ALTITUDE = 0.05;
    var autoMapCooldownUntil = 0;

    function vectorOverlayStrengthForAltitude(alt) {
        // 0 = longe (globo fotográfico), 1 = perto (hora do mapa 2D)
        if (alt >= VECTOR_FADE_START) return 0;
        var t = (VECTOR_FADE_START - alt) / (VECTOR_FADE_START - AUTO_MAP_ALTITUDE);
        return Math.max(0, Math.min(1, t));
    }

    function photoDimForAltitude(alt) {
        var t = vectorOverlayStrengthForAltitude(alt);
        return 1 - t * 0.45; // escurece só na aproximação final, sem matar a foto
    }

    function applyVectorOverlayFrame(force) {
        if (!globe) return;
        var alt = getCameraAltitude();
        var t = vectorOverlayStrengthForAltitude(alt);

        var dim = photoDimForAltitude(alt);
        var mat = (typeof globe.globeMaterial === 'function') ? globe.globeMaterial() : null;
        if (mat && 'color' in mat && mat.color && typeof mat.color.setScalar === 'function') {
            mat.color.setScalar(dim);
        }

        if (t >= 1 && alt <= AUTO_MAP_ALTITUDE && !isRegionMapOpen() && Date.now() >= autoMapCooldownUntil) {
            autoMapCooldownUntil = Date.now() + 4000; // evita reabrir logo após fechar
            var pov = globe.pointOfView();
            if (typeof globe.pauseAnimation === 'function') globe.pauseAnimation();
            openRegionMap({ lat: pov.lat, lng: pov.lng, count: 0, title: '' });
        }
    }

    function loadRegionGeography() {
        if (!regionGeographyPromise) {
            regionGeographyPromise = fetch(REGION_GEOGRAPHY_URL, { credentials: 'same-origin' })
                .then(function (response) {
                    if (!response.ok) throw new Error('HTTP ' + response.status);
                    return response.json();
                })
                .then(function (geojson) {
                    if (!geojson || geojson.type !== 'FeatureCollection' || !Array.isArray(geojson.features)) {
                        throw new Error('invalid_world_geography');
                    }
                    return geojson;
                })
                .catch(function (err) {
                    regionGeographyPromise = null;
                    throw err;
                });
        }
        return regionGeographyPromise;
    }

    function loadRegionAdmin1() {
        if (!regionAdmin1Promise) {
            regionAdmin1Promise = fetch(REGION_ADMIN1_URL, { credentials: 'same-origin' })
                .then(function (response) {
                    if (!response.ok) throw new Error('HTTP ' + response.status);
                    return response.json();
                })
                .then(function (geojson) {
                    if (!geojson || geojson.type !== 'FeatureCollection' || !Array.isArray(geojson.features)) {
                        throw new Error('invalid_admin1_geography');
                    }
                    return geojson;
                })
                .catch(function (err) {
                    regionAdmin1Promise = null;
                    throw err;
                });
        }
        return regionAdmin1Promise;
    }

    function loadLeaflet() {
        if (leafletLoading) return leafletLoading;
        // Leaflet core primeiro; depois o plugin de cluster (depende de L global).
        leafletLoading = Promise.all([
            loadCss(LEAFLET_CSS_URL),
            loadCss(LEAFLET_CLUSTER_CSS_URL),
            loadCss(LEAFLET_CLUSTER_DEFAULT_CSS_URL),
            loadScript(LEAFLET_JS_URL)
        ]).then(function () {
            // O plugin precisa do L global definido antes de carregar.
            return loadScript(LEAFLET_CLUSTER_JS_URL);
        });
        return leafletLoading;
    }

    function isRegionMapOpen() {
        return !!(regionOverlay && !regionOverlay.hidden);
    }

    function clearRegionResizeTimers() {
        regionResizeTimers.forEach(function (id) { clearTimeout(id); });
        regionResizeTimers = [];
    }

    function scheduleRegionMapResize() {
        if (!regionMap || !isRegionMapOpen()) return;
        clearRegionResizeTimers();
        var run = function () {
            if (!regionMap || !isRegionMapOpen()) return;
            try {
                regionMap.invalidateSize({ animate: false, pan: false });
            } catch (e) { /* ignore */ }
        };
        if (typeof requestAnimationFrame === 'function') {
            requestAnimationFrame(function () {
                run();
                requestAnimationFrame(run);
            });
        }
        [50, 180, 360].forEach(function (ms) {
            regionResizeTimers.push(setTimeout(run, ms));
        });
    }

    /** Aguarda o container do Leaflet ter altura real (evita faixa fina ao abrir/fechar rápido). */
    function whenRegionMapContainerReady(callback) {
        var container = document.getElementById('rp-region-map');
        if (!container || typeof callback !== 'function') return;

        var attempts = 0;
        function tick() {
            if (!isRegionMapOpen()) return;
            var rect = container.getBoundingClientRect();
            if (rect.height >= 120 && rect.width >= 120) {
                callback(container);
                return;
            }
            attempts += 1;
            if (attempts >= 40) {
                callback(container);
                return;
            }
            requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
    }

    function destroyRegionMap() {
        clearRegionResizeTimers();
        if (regionMoveDebounce) {
            clearTimeout(regionMoveDebounce);
            regionMoveDebounce = null;
        }
        regionMoveAttached = false;
        regionSkipNextMoveEnd = false;
        regionLastFetchCenter = null;
        regionLastFetchRadius = 0;
        regionDataMode = 'stations';
        regionWorldZoom = null;
        regionWorldPendingZoom = null;
        regionFetchToken += 1;

        if (regionMap) {
            try {
                regionMap.off();
                regionMap.remove();
            } catch (e) { /* ignore */ }
            regionMap = null;
        }

        regionClusterGroup = null;
        regionMarkers = [];
        regionMarkersById = {};

        var container = document.getElementById('rp-region-map');
        if (container) {
            container.innerHTML = '';
            container.removeAttribute('style');
        }
    }

    function openRegionMap(point) {
        var openToken = ++regionOpenToken;
        var ov = ensureRegionOverlay();
        ov.hidden = false;
        document.body.classList.add('rp-region-open');

        // Pausa o render loop do globe.gl enquanto o modal 2D está visível —
        // mesmo invisível por trás do overlay, o WebGL continua a desenhar
        // (auto-rotate, ring pulsante, etc.) e disputa GPU com o Leaflet.
        if (globe && typeof globe.pauseAnimation === 'function') {
            globe.pauseAnimation();
        }

        var titleEl = ov.querySelector('.rp-region-map-title');
        var metaEl = ov.querySelector('.rp-region-map-meta');
        var loadingEl = ov.querySelector('.rp-region-map-loading');
        if (titleEl) titleEl.textContent = (point.count || 0) + ' rádios na região';
        if (metaEl) metaEl.textContent = point.title ? 'Próxima: ' + point.title : '';
        if (loadingEl) loadingEl.hidden = false;

        // Raio escala com o zoom level — clusters de células maiores (zoom=1, 2)
        // precisam de raio maior para cobrir toda a área que representam.
        var radiusKm = regionRadiusForZoom(currentZoomLevel);
        loadLeaflet().then(function () {
            if (openToken !== regionOpenToken || !isRegionMapOpen()) return null;
            return fetchJson(ENDPOINT_CLUSTER
                + '?lat=' + encodeURIComponent(point.lat)
                + '&lng=' + encodeURIComponent(point.lng)
                + '&radius_km=' + radiusKm
                + '&limit=' + REGION_STATION_LIMIT);
        }).then(function (j) {
            if (openToken !== regionOpenToken || !isRegionMapOpen()) return;
            if (loadingEl) loadingEl.hidden = true;
            if (!j) return;
            var stations = (j && j.success && Array.isArray(j.stations)) ? j.stations : [];
            whenRegionMapContainerReady(function () {
                if (openToken !== regionOpenToken || !isRegionMapOpen()) return;
                renderRegionMap(point.lat, point.lng, stations, openToken);
            });
        }).catch(function (err) {
            if (openToken !== regionOpenToken || !isRegionMapOpen()) return;
            if (loadingEl) loadingEl.hidden = true;
            if (window.console && console.warn) console.warn('region map failed:', err);
            if (metaEl) metaEl.textContent = 'Erro ao carregar mapa da região.';
        });
    }

    function renderRegionMap(lat, lng, stations, openToken) {
        if (typeof openToken === 'number' && (openToken !== regionOpenToken || !isRegionMapOpen())) return;
        var L = window.L;
        if (!L) return;
        var container = document.getElementById('rp-region-map');
        if (!container) return;

        if (regionMap) {
            destroyRegionMap();
        }

        regionMap = L.map(container, {
            center: [lat, lng],
            zoom: 5,
            minZoom: 2,
            maxZoom: 17,
            zoomControl: true,
            scrollWheelZoom: true,
            worldCopyJump: true,
            preferCanvas: true
        });
        container.style.background = REGION_MAP_BACKGROUND;
        // Tiles OSM: detalhe de ruas/bairros. Abaixo do pane vetorial.
        regionMap.createPane('rp-osm-tiles');
        regionMap.getPane('rp-osm-tiles').style.zIndex = '200';
        regionMap.createPane('rp-world-borders');
        regionMap.getPane('rp-world-borders').style.zIndex = '390';
        L.tileLayer(REGION_TILE_URL, {
            attribution: REGION_TILE_ATTR,
            maxZoom: 17,
            keepBuffer: 3,
            updateWhenIdle: false
        }).addTo(regionMap);
        regionMap.on('zoomend', function () {
            // No close zoom os tiles OSM têm mais detalhe que o vetorial — some com ele.
            var pane = regionMap.getPane('rp-world-borders');
            if (pane) pane.style.opacity = regionMap.getZoom() >= 9 ? '0' : '1';
        });
        var geographyMap = regionMap;
        loadRegionGeography().then(function (geojson) {
            if (regionMap !== geographyMap || !isRegionMapOpen()) return;
            L.geoJSON(geojson, {
                pane: 'rp-world-borders',
                interactive: false,
                style: function () {
                    return {
                        color: 'rgba(111, 168, 206, 0.38)',
                        weight: 0.8,
                        opacity: 0.8,
                        fillColor: '#16334a',
                        fillOpacity: 0.88
                    };
                }
            }).addTo(regionMap);
        }).catch(function (err) {
            if (window.console && console.warn) console.warn('world geography unavailable:', err);
        });
        loadRegionAdmin1().then(function (admin1) {
            if (regionMap !== geographyMap || !isRegionMapOpen()) return;
            L.geoJSON(admin1, {
                pane: 'rp-world-borders',
                interactive: false,
                style: function () {
                    return {
                        color: 'rgba(143, 190, 222, 0.58)',
                        weight: 0.55,
                        opacity: 0.68,
                        fill: false
                    };
                }
            }).addTo(geographyMap);
        }).catch(function (err) {
            if (window.console && console.warn) console.warn('admin-1 boundaries unavailable:', err);
        });

        // Marcadores iniciais a partir do payload do cluster clicado.
        populateRegionMarkers(stations);

        // Ajusta viewport para mostrar todos os marcadores se houver +1.
        // Esse fitBounds vai disparar moveend — marcamos para ignorar.
        if (regionMarkers.length > 1) {
            var group = L.featureGroup(regionMarkers);
            regionSkipNextMoveEnd = true;
            regionMap.fitBounds(group.getBounds().pad(0.15), { maxZoom: 11 });
        }

        // Liga o refetch dinâmico: quando o utilizador panar/zoom, busca as
        // rádios da nova região visível (não fica preso ao cluster original).
        attachRegionMoveHandler();
        scheduleRegionMapResize();
    }

    function formatRadioCount(count) {
        var total = Math.max(0, Number(count) || 0);
        if (total >= 1000000) {
            var millions = (total / 1000000).toFixed(1);
            return (millions.endsWith('.0') ? millions.slice(0, -2) : millions) + 'M';
        }
        if (total >= 1000) {
            var thousands = (total / 1000).toFixed(1);
            return (thousands.endsWith('.0') ? thousands.slice(0, -2) : thousands) + 'k';
        }
        return String(total);
    }

    function createStationMarker(s) {
        var L = window.L;
        var icon;
        if (s.isGlobeCluster) {
            var size = 28 + Math.min(20, Math.round(Math.log10(s.count + 1) * 6));
            icon = L.divIcon({
                className: 'rp-region-marker rp-region-world-marker',
                html: '<span class="rp-region-world-dot">' + formatRadioCount(s.count) + '</span>',
                iconSize: [size, size],
                iconAnchor: [size / 2, size / 2]
            });
        } else {
            icon = L.divIcon({
                className: 'rp-region-marker',
                html: '<span class="rp-region-marker-dot"></span>',
                iconSize: [18, 18],
                iconAnchor: [9, 9]
            });
        }
        var marker = L.marker([s.lat, s.lng], { icon: icon, title: s.title || '' });
        if (s.isGlobeCluster) {
            marker.on('click', function () {
                if (!regionMap) return;
                regionMap.setView([s.lat, s.lng], Math.min(10, Math.max(7, regionMap.getZoom() + 2)));
            });
        } else {
            marker.bindPopup(buildStationPopup(s), { closeButton: true, autoPan: true });
            marker.on('click', function () {
                if (s.stream_url && s.id && window.radioManager && typeof window.radioManager.playRadio === 'function') {
                    window.radioManager.playRadio(s.stream_url, s.id, s.title || '', s.logo || '');
                }
            });
        }
        // Referência usada pelo popup-lista quando o utilizador clica num cluster.
        marker.rpStation = s;
        return marker;
    }

    /**
     * Diff: adiciona apenas marcadores novos, remove os que sumiram do fetch.
     * Preserva instâncias existentes (mantém popup aberto, click state, etc).
     * Muito mais barato que clearLayers + add em massa.
     */
    function populateRegionMarkers(stations) {
        var L = window.L;
        if (!L || !regionMap) return;

        // Lazy-init do cluster group na primeira chamada.
        if (!regionClusterGroup && typeof L.markerClusterGroup === 'function') {
            regionClusterGroup = L.markerClusterGroup({
                showCoverageOnHover: false,
                // Desliga zoom/spiderfy ao clicar — vamos abrir uma LISTA das rádios
                // do cluster (mais legível que radial-spider quando há 65+ marcadores).
                zoomToBoundsOnClick: false,
                spiderfyOnMaxZoom: false,
                maxClusterRadius: 55,
                chunkedLoading: true,
                chunkInterval: 100,
                chunkDelay: 50,
                iconCreateFunction: function (cluster) {
                    var children = cluster.getAllChildMarkers();
                    var n = children.reduce(function (total, marker) {
                        var station = marker.rpStation || {};
                        return total + (station.isGlobeCluster ? (Number(station.count) || 1) : 1);
                    }, 0);
                    var size = 32 + Math.min(20, Math.round(Math.log10(n + 1) * 8));
                    return L.divIcon({
                        className: 'rp-region-cluster',
                        html: '<div class="rp-region-cluster-inner"><span>' + formatRadioCount(n) + '</span></div>',
                        iconSize: [size, size],
                        iconAnchor: [size / 2, size / 2]
                    });
                }
            });
            regionClusterGroup.on('clusterclick', onClusterListPopup);
            regionMap.addLayer(regionClusterGroup);
        }

        var fallback = !regionClusterGroup;
        var newIds = {};
        var toAdd = [];

        stations.forEach(function (s) {
            if (!s.id) return;
            if (typeof s.lat !== 'number' || typeof s.lng !== 'number') return;
            if (!s.stream_url && !s.isGlobeCluster) return;
            newIds[s.id] = s;
            if (!regionMarkersById[s.id]) {
                var marker = createStationMarker(s);
                regionMarkersById[s.id] = marker;
                toAdd.push(marker);
            }
        });

        // Remove marcadores que sumiram do novo fetch.
        Object.keys(regionMarkersById).forEach(function (id) {
            if (newIds[id]) return;
            var m = regionMarkersById[id];
            if (fallback) regionMap.removeLayer(m);
            else regionClusterGroup.removeLayer(m);
            delete regionMarkersById[id];
        });

        // Adiciona novos em batch (mais eficiente que um-a-um).
        if (toAdd.length > 0) {
            if (fallback) toAdd.forEach(function (m) { m.addTo(regionMap); });
            else regionClusterGroup.addLayers(toAdd);
        }

        // Mantém array legacy para fitBounds inicial
        regionMarkers = Object.keys(regionMarkersById).map(function (id) {
            return regionMarkersById[id];
        });
    }

    /**
     * Liga o evento moveend (debounced) para refetch baseado no viewport actual.
     * O endpoint cluster-stations aceita lat/lng/radius arbitrários (até 200 limit),
     * então usamos o centro + canto do bounds visível para definir uma busca circular
     * que cobre tudo o que o utilizador está a ver.
     */
    function attachRegionMoveHandler() {
        if (!regionMap || regionMoveAttached) return;
        regionMoveAttached = true;
        regionMap.on('moveend', function () {
            if (regionSkipNextMoveEnd) { regionSkipNextMoveEnd = false; return; }
            if (regionMoveDebounce) clearTimeout(regionMoveDebounce);
            // Debounce mais longo (700ms): pan curto não dispara fetch
            regionMoveDebounce = setTimeout(refetchRegionForViewport, 700);
        });
    }

    function refetchRegionForViewport() {
        if (!regionMap || !isRegionMapOpen()) return;
        var map = regionMap;
        var mapZoom = map.getZoom();
        var globeZoom = globeZoomForRegionMapZoom(mapZoom);
        var titleEl = regionOverlay && regionOverlay.querySelector('.rp-region-map-title');
        var metaEl = regionOverlay && regionOverlay.querySelector('.rp-region-map-meta');
        var loadingEl = regionOverlay && regionOverlay.querySelector('.rp-region-map-loading');

        // Em zoom distante, usa o feed global do globo — não /nearby-stations,
        // que devolve no máximo 200 rádios próximos e deixa o resto do planeta vazio.
        if (globeZoom !== null) {
            if (regionDataMode === 'world' && regionWorldZoom === globeZoom) return;
            if (regionWorldPendingZoom === globeZoom) return;
            regionDataMode = 'world';
            regionWorldZoom = null;
            regionWorldPendingZoom = globeZoom;
            regionLastFetchCenter = null;
            regionLastFetchRadius = 0;
            var worldToken = ++regionFetchToken;
            if (loadingEl) loadingEl.hidden = false;

            fetchJson(ENDPOINT_GLOBE + '?zoom=' + globeZoom).then(function (j) {
                if (worldToken !== regionFetchToken || map !== regionMap || !isRegionMapOpen()) return;
                regionWorldPendingZoom = null;
                if (loadingEl) loadingEl.hidden = true;
                if (!j || !j.success || !Array.isArray(j.clusters)) {
                    regionWorldZoom = null;
                    return;
                }
                var clusters = j.clusters;
                populateRegionMarkers(globeClustersToStations(clusters, globeZoom));
                regionWorldZoom = globeZoom;
                var totalRadios = clusters.reduce(function (total, cluster) {
                    return total + (Number(cluster.count) || 0);
                }, 0);
                if (titleEl) titleEl.textContent = formatRadioCount(totalRadios) + ' rádios em ' + clusters.length + ' clusters no mundo';
                if (metaEl) metaEl.textContent = 'Toque em um cluster para aproximar';
            }).catch(function () {
                if (worldToken !== regionFetchToken || map !== regionMap) return;
                regionWorldPendingZoom = null;
                regionWorldZoom = null;
                if (loadingEl) loadingEl.hidden = true;
            });
            return;
        }

        // Em zoom local, volta a carregar rádios reais na área visível.
        if (regionDataMode !== 'stations') {
            regionDataMode = 'stations';
            regionWorldZoom = null;
            regionWorldPendingZoom = null;
            regionLastFetchCenter = null;
            regionLastFetchRadius = 0;
            regionFetchToken += 1; // invalida um fetch global que ainda esteja em voo
        }

        var bounds = map.getBounds();
        var center = bounds.getCenter();
        var ne = bounds.getNorthEast();
        // Raio circular que contém o canto mais distante do viewport (cobre tudo visível).
        var radiusKm = Math.max(20, Math.min(20000, center.distanceTo(ne) / 1000));

        // Smart cache: pan/zoom pequeno → reusa fetch anterior (sem network round-trip).
        // Critério: movimento menor que 35% do raio actual E raio mudou menos de 25%.
        if (regionLastFetchCenter) {
            var movedKm = regionLastFetchCenter.distanceTo(center) / 1000;
            var radiusDelta = Math.abs(radiusKm - regionLastFetchRadius) / Math.max(radiusKm, regionLastFetchRadius);
            if (movedKm < radiusKm * 0.35 && radiusDelta < 0.25) {
                return; // viewport ainda coberto pelo fetch anterior
            }
        }
        regionLastFetchCenter = center;
        regionLastFetchRadius = radiusKm;

        var stationToken = ++regionFetchToken;
        if (loadingEl) loadingEl.hidden = false;
        fetchJson(ENDPOINT_CLUSTER
            + '?lat=' + center.lat
            + '&lng=' + center.lng
            + '&radius_km=' + radiusKm.toFixed(1)
            + '&limit=' + REGION_STATION_LIMIT
        ).then(function (j) {
            if (stationToken !== regionFetchToken || map !== regionMap || !isRegionMapOpen()) return;
            if (loadingEl) loadingEl.hidden = true;
            if (!j || !j.success) return;
            var stations = Array.isArray(j.stations) ? j.stations : [];
            populateRegionMarkers(stations);
            if (titleEl) {
                titleEl.textContent = stations.length + (stations.length === 1
                    ? ' rádio visível nesta área'
                    : ' rádios visíveis nesta área');
            }
            if (metaEl) metaEl.textContent = 'Raio ~' + Math.round(radiusKm) + ' km';
        }).catch(function () {
            if (stationToken === regionFetchToken && loadingEl) loadingEl.hidden = true;
        });
    }

    /**
     * Cluster global clicado → aproxima para carregar rádios reais naquela área.
     * Cluster local de estações → abre a lista de rádios reproduzíveis.
     */
    function onClusterListPopup(ev) {
        var L = window.L;
        if (!L || !ev || !ev.layer) return;
        var children = ev.layer.getAllChildMarkers();
        var childStations = children.map(function (m) { return m.rpStation; }).filter(Boolean);
        if (childStations.some(function (s) { return s.isGlobeCluster; })) {
            if (regionMap && children.length > 0) {
                var maxZoom = Math.min(10, regionMap.getZoom() + 2);
                regionMap.fitBounds(ev.layer.getBounds().pad(0.25), { maxZoom: maxZoom });
            }
            return;
        }
        var stations = childStations.filter(function (s) { return s.stream_url; });
        if (stations.length === 0) return;

        // Ordena por título para tornar a lista mais navegável.
        stations.sort(function (a, b) {
            return String(a.title || '').localeCompare(String(b.title || ''));
        });

        var headerCountLabel = stations.length + (stations.length === 1 ? ' rádio neste ponto' : ' rádios neste ponto');
        var html = ''
            + '<div class="rp-cluster-list-header"><strong>' + headerCountLabel + '</strong></div>'
            + (stations.length > 4
                ? '<div class="rp-cluster-filter-wrap">'
                +    '<i class="fas fa-search rp-cluster-filter-icon" aria-hidden="true"></i>'
                +    '<input type="search" class="rp-cluster-filter" placeholder="Filtrar por nome…" aria-label="Filtrar rádios"'
                +      ' data-total="' + stations.length + '">'
                + '</div>'
                : '')
            + '<div class="rp-cluster-list" role="listbox">'
            + stations.map(function (s) {
                var safeTitle = escapeHtml(s.title || '');
                var safeMeta = escapeHtml(s.segmento || s.localizacao || '');
                var logo = s.logo ? escapeHtml(s.logo) : '';
                var stream = escapeHtml(s.stream_url || '');
                return '<button type="button" class="rp-cluster-list-item" role="option"'
                    +    ' data-id="' + (s.id || 0) + '"'
                    +    ' data-stream="' + stream + '"'
                    +    ' data-title="' + safeTitle + '"'
                    +    ' data-logo="' + logo + '">'
                    +    (logo
                        ? '<img class="rp-cluster-list-logo" src="' + logo + '" alt="" loading="lazy" onerror="this.style.visibility=\'hidden\'">'
                        : '<span class="rp-cluster-list-logo"></span>')
                    +    '<span class="rp-cluster-list-info">'
                    +      '<span class="rp-cluster-list-title">' + safeTitle + '</span>'
                    +      (safeMeta ? '<span class="rp-cluster-list-meta">' + safeMeta + '</span>' : '')
                    +    '</span>'
                    +    '<i class="fas fa-play rp-cluster-list-play" aria-hidden="true"></i>'
                    +  '</button>';
            }).join('')
            + '</div>';

        L.popup({
            closeButton: true,
            autoPan: true,
            maxWidth: 320,
            minWidth: 240,
            className: 'rp-cluster-popup'
        })
            .setLatLng(ev.latlng)
            .setContent(html)
            .openOn(regionMap);
    }

    function buildStationPopup(s) {
        var safeTitle = escapeHtml(s.title || '');
        var safeSeg = escapeHtml(s.segmento || s.localizacao || '');
        var logo = s.logo ? escapeHtml(s.logo) : '';
        return '<div class="rp-region-popup">'
            + (logo ? '<img src="' + logo + '" alt="" class="rp-region-popup-logo" onerror="this.style.display=\'none\'">' : '')
            + '<strong>' + safeTitle + '</strong>'
            + (safeSeg ? '<span>' + safeSeg + '</span>' : '')
            + '</div>';
    }

    function closeRegionMap() {
        autoMapCooldownUntil = Date.now() + 4000;

        regionOpenToken += 1;
        destroyRegionMap();
        if (regionOverlay) regionOverlay.hidden = true;
        document.body.classList.remove('rp-region-open');
        // Retoma o render loop do globo agora que o utilizador vai voltar a vê-lo.
        if (globe && typeof globe.resumeAnimation === 'function') {
            globe.resumeAnimation();
        }
    }

    // -- Global handlers ------------------------------------------------------

    // Click num item da lista de cluster (popup Leaflet) → toca rádio + fecha popup.
    document.addEventListener('click', function (ev) {
        var item = ev.target && ev.target.closest && ev.target.closest('.rp-cluster-list-item');
        if (!item) return;
        var stream = item.getAttribute('data-stream') || '';
        var id = parseInt(item.getAttribute('data-id') || '0', 10);
        var title = item.getAttribute('data-title') || '';
        var logo = item.getAttribute('data-logo') || '';
        if (stream && id && window.radioManager && typeof window.radioManager.playRadio === 'function') {
            window.radioManager.playRadio(stream, id, title, logo);
            if (regionMap && typeof regionMap.closePopup === 'function') regionMap.closePopup();
        }
    });

    // Filtro por nome dentro do popup-lista de cluster.
    document.addEventListener('input', function (ev) {
        var input = ev.target;
        if (!input || !input.classList || !input.classList.contains('rp-cluster-filter')) return;
        var query = (input.value || '').trim().toLowerCase();
        var wrap = input.closest('.leaflet-popup-content');
        if (!wrap) return;
        var items = wrap.querySelectorAll('.rp-cluster-list-item');
        var visible = 0;
        items.forEach(function (item) {
            var title = (item.getAttribute('data-title') || '').toLowerCase();
            var match = !query || title.indexOf(query) !== -1;
            item.style.display = match ? '' : 'none';
            if (match) visible++;
        });
        // Atualiza o header com a contagem visível quando há filtro activo.
        var header = wrap.querySelector('.rp-cluster-list-header strong');
        if (header) {
            var total = parseInt(input.getAttribute('data-total') || '0', 10);
            if (query === '') {
                header.textContent = total + (total === 1 ? ' rádio neste ponto' : ' rádios neste ponto');
            } else {
                header.textContent = visible + ' de ' + total + ' rádios';
            }
        }
    });

    if (discoverBtn) {
        discoverBtn.addEventListener('click', function (e) {
            e.preventDefault();
            toggleDiscoveryMode();
        });
    }

    // Click fora do hero sai do modo descoberta
    document.addEventListener('click', function (ev) {
        if (!hero || !discoveryMode) return;
        var t = ev.target;
        if (!t || !t.closest) return;
        if (t.closest('#rp-globe-discover')) return;
        if (t.closest('.rp-region-map-overlay')) return;
        if (!t.closest('.rp-hero')) {
            exitDiscoveryMode();
        }
    }, true);

    // IntersectionObserver: hero em vista → body.rp-in-hero-view
    if (hero && typeof window.IntersectionObserver === 'function') {
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
                if (e.isIntersecting && e.intersectionRatio >= 0.4) {
                    document.body.classList.add('rp-in-hero-view');
                } else {
                    document.body.classList.remove('rp-in-hero-view');
                }
            });
        }, { threshold: [0, 0.4, 0.6, 1] });
        io.observe(hero);
    } else if (hero) {
        document.body.classList.add('rp-in-hero-view');
        window.addEventListener('scroll', function () {
            var rect = hero.getBoundingClientRect();
            if (rect.bottom > window.innerHeight * 0.4) {
                document.body.classList.add('rp-in-hero-view');
            } else {
                document.body.classList.remove('rp-in-hero-view');
            }
        }, { passive: true });
    }

    if (document.readyState === 'loading') {
        rpOnReady( scheduleGlobeInit);
    } else {
        scheduleGlobeInit();
    }
})();

}
